import { criarPedidoDoOrcamento } from "../utils/pedidoDoOrcamento";
import { CatalogoOrcamento } from "./commerce/CatalogoOrcamento";
import "./commerce/commerce.css";
import { useState, useEffect, useRef } from "react";
import { toast } from "../hooks/useToast";
import {C, withAlpha } from "../constants/theme";
import { fbList, fbAdd, fbUpdate } from "../hooks/useFirebase";
import { Card } from "./ui/Card";
import { Btn } from "./ui/Btn";
import { FotoUploader } from "./ui/FotoUploader";
import { Lightbox } from "./ui/Lightbox";
import { extrairFoto3mf, imagemParaBase64, extrairPlacas3mf } from "../utils/extract3mf";
import { extrairMetaGcodeDeArquivo } from "../utils/gcodeMeta";
import { materiaisDoResultado, resumirPlacas, filamentosDetectados, listarPlacasImportacao, separarPlacasParaFatiar, resultadoSalvoDaImpressora } from "../utils/importacaoFatiamento";
import { salvarFotoBase64NoStorage } from "../utils/fotosProduto";
import { arredondarHoras } from "../utils/horas";
import { ImportarMakerWorldCalculadora } from "./makerworld/ImportarMakerWorldCalculadora";
import { importarFotosMakerWorld, miniaturasFotosMakerWorld } from "./makerworld/makerworldApi";
import { FaixaFotosMakerWorld } from "./makerworld/FaixaFotosMakerWorld";
import { CampoLinkMakerWorld } from "./makerworld/CampoLinkMakerWorld";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { doc, getDoc } from "firebase/firestore";
import { auth, db, storage } from "../firebase";
import { getUser } from "../utils/sessao";
import { useOcultarValores } from "../hooks/useOcultarValores";
import { useAvisoAoSair } from "../hooks/useAvisoAoSair";
import { emojiDaCategoria, sugerirCategoriasProduto } from "../utils/categoriasProduto";
import { useConfirm } from "../hooks/useConfirm";
import {
  salvarOrcamento, getOrcamento, listarOrcamentos, apagarOrcamento,
  adicionarItemOrcamento, atualizarItemOrcamento, atualizarPrecosOrcamento, removerItemOrcamento, atualizarNomeClienteOrcamento,
  gerarLinkOrcamento, linkOrcamento,
} from "../utils/orcamentos";
import { corFilamentoHex, encontrarFilamentoMaisProximo } from "../utils/corFilamento";
import { useCalculoProduto } from "../hooks/useCalculoProduto";
import { margemMaxima, limitarMargem } from "../calculator/margem";
import { planejarPrecoOrcamento } from "../utils/precoOrcamento";
import { resolverPreco } from "../calculator/engine";
import { salvarHistoricoCalculo, listarHistoricoCalculos } from "../utils/historicoCalculos";
import { traduzirErroFatiamento } from "../utils/erroFatiamento";
import { placasFatiadasDoResultado, arquivoPermanente3d, prepararArquivo3d, visualizacao3dDoItem, visualizacao3dDoArquivo } from "../utils/visualizacao3d";
import { TelaInicio } from "./calculadora/TelaInicio";
import { TelaCalculadora } from "./calculadora/TelaCalculadora";
import { CalcIcon } from "./calculadora/CalcIcon";
import { TelaSucesso } from "./calculadora/TelaSucesso";
import { ModalAdicionarOrcamento } from "./calculadora/ModalAdicionarOrcamento";
import { TelaNovoOrcamento } from "./calculadora/TelaNovoOrcamento";
import { TelaOrcamentos } from "./calculadora/TelaOrcamentos";
import { OrcamentoBotao, OrcamentoCampo, OrcamentoCabecalho, OrcamentoFinanceiro, moedaOrcamento } from "./calculadora/OrcamentoUI";
import { CommerceDialog } from "./commerce/CommerceDialog";
import { Visualizador3D } from "./Visualizador3D";
import { TelaHistorico } from "./calculadora/TelaHistorico";
import { SubNavCalculadora } from "./calculadora/SubNavCalculadora";
import { AbasArquivos } from "./calculadora/AbasArquivos";
import { calcularResultado } from "../calculator/resultado";
import { nomeDoArquivo, nomeDoItem, unidadesDoItem, calculoDoNovoItem, depoisDeRemover } from "../utils/itensArquivo";
import "./calculadora/calculadora.css";

const RASCUNHO_KEY = "3dp_calc_orc_rascunho";
// Fotos do orçamento ficam em base64 dentro do documento (limite de 1 MB no
// Firestore), então o MakerWorld traz só as primeiras — ~20 KB cada.
const LIMITE_FOTOS_ORCAMENTO = 6;
// Teto de fotos por importação pra galeria do produto (LIMITES.maxImagensPorImportacao no backend).
const LIMITE_FOTOS_PRODUTO = 30;

const SLICER_BASE = process.env.REACT_APP_SLICER_URL
  || (process.env.NODE_ENV === "development" ? "http://localhost:8080" : "https://slicer-service-282106794112.us-central1.run.app");
const INSPECT_URL = `${SLICER_BASE}/inspect`;
const SLICE_URL = `${SLICER_BASE}/slice`;

// Chamadas ao fatiador com tempo limite: sem isso, um serviço travado deixava o
// botão de importar "carregando" para sempre. Erros de rede viram texto em português.
async function fetchFatiador(url, opcoes, limiteMs) {
  try {
    return await fetch(url, { ...opcoes, signal: AbortSignal.timeout(limiteMs) });
  } catch (e) {
    if (e?.name === "TimeoutError") throw new Error("O fatiador não respondeu a tempo. Tente novamente mais tarde.");
    if (e instanceof TypeError) throw new Error("Não foi possível conectar ao fatiador. Tente novamente mais tarde.");
    throw e;
  }
}

// Fatiamento automático (botão "Importar 3MF/GCODE") — motor trocado pro
// Bambu Studio nativo com perfis oficiais por impressora (ver
// slicer-service/README.md). Validado em 13/09/2026 contra fatiamento
// direto no Bambu Studio (mesma peça, troca de impressora P1S→A1): diferença
// menor que 1s no tempo total em 7 placas. Liberado pra todo mundo — mas só
// funciona de fato depois que o slicer-service (Cloud Run) for republicado
// com o motor novo, já que o contrato da API mudou (ver /health apiVersion 3).
const IMPORTAR_3MF_ATIVO = true;

// Popup centralizado, mesmo padrão visual usado no resto do app
function Popup({ titulo, cor, onClose, children, closeDataTour, ...rest }) {
  return (
    <>
      <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:1000 }} />
      <div {...rest} className="calc-budget-dialog" style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:"min(440px,94vw)", maxHeight:"88vh", overflowY:"auto", background:C.panel, border:"1px solid "+withAlpha(cor, "44"), borderRadius:18, padding:20, zIndex:1001, boxShadow:"0 24px 64px rgba(0,0,0,0.7)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
          <span style={{ color:cor, fontWeight:900, fontSize:14, letterSpacing:1 }}>{titulo}</span>
          <button data-tour={closeDataTour} onClick={onClose} style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>✕</button>
        </div>
        {children}
      </div>
    </>
  );
}

// Classifica um orçamento salvo num dos 3 status mostrados na lista/filtro —
// deriva tudo do que abrirListaOrcamentos() já busca (o._pub), sem precisar
// de mais nenhum campo novo no Firestore.
function statusOrcamento(o) {
  if (!o.link_gerado || !o._pub) return "aguardando"; // ainda não mandou o link
  const expirado = o._pub.expira_em?.toDate ? o._pub.expira_em.toDate() < new Date() : true;
  if (expirado) return "expirado";
  if (o._pub.totalItens > 0 && o._pub.aprovadosCount === o._pub.totalItens) return "aprovado";
  return "aguardando";
}

// Sobe o modelo 3D de exibição (ativa o botão "Ver em 3D" pro cliente) e
// monta o registro de arquivo + o campo visualizacao3d — sempre com TODAS
// as placas do arquivo, sem seleção manual: anexar aqui já é "colocar um 3D
// pra ser visualizado". Compartilhado entre registrar produto e orçamento.
async function prepararModelo3dExibicao(basePath, file) {
  const path = `${basePath}/${Date.now()}_display_${file.name}`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  const url = await getDownloadURL(storageRef);
  const entrada = { nome: file.name, path, url };
  const placasGaleria = await extrairPlacas3mf(file);
  if (placasGaleria?.length) entrada.placas = placasGaleria;
  entrada.placasSelecionadas = placasGaleria?.length ? placasGaleria.map(p => p.indice) : [1];
  return { arquivo: entrada, visualizacao3d: visualizacao3dDoArquivo(entrada) };
}

export function Calculadora({ coresCustom, telaInicial = "inicio", onIrPedidos, tutorialAtivo = false }) {
  // Núcleo de precificação centralizado — busca filamentos/impressoras/
  // materiais/perfil e resolve o preço em tempo real (src/calculator/engine.js).
  // Modo Rápido, Modo Avançado e "Registrar Produto"/"Adicionar ao
  // Orçamento" abaixo todos leem daqui, nunca duplicam a fórmula.
  const calculo = useCalculoProduto();
  const { filamentos, impressoras, resultado } = calculo;

  const [clientes, setClientes] = useState([]); // cadastro em Clientes — orçamento conecta com isso
  const [produtos, setProdutos] = useState([]); // cadastro em Produtos — usado pra achar/criar produto ao gerar pedido manualmente
  const [ocultar, toggleOcultar] = useOcultarValores();
  const [modalAberto, setModalAberto] = useState(null); // "orcamento" (editar item existente) | "adicionar-orcamento" (novo, 2 passos) | "registrar" (registrar produto) | null
  const [passoAdicionar, setPassoAdicionar] = useState("produto"); // "produto" | "cliente" — passo do modal "adicionar-orcamento"
  const [precoEditavel, setPrecoEditavel] = useState(false); // "Alterar preço" no passo Produto
  const [novoClienteAberto, setNovoClienteAberto] = useState(false);
  const [novoClienteNome, setNovoClienteNome] = useState("");
  const [novoClienteCelular, setNovoClienteCelular] = useState("");
  const [salvandoNovoCliente, setSalvandoNovoCliente] = useState(false);
  // Tela ativa dentro da Calculadora — 'inicio' é a Home; 'calculadora',
  // 'orcamentos' e 'historico' são as 3 áreas principais (com sub-nav entre
  // elas); as demais são telas secundárias, cada uma com seu próprio destino
  // de volta explícito (não usam mais um "voltar genérico").
  const [tela, setTela] = useState(telaInicial);
  useEffect(() => {
    if (tutorialAtivo) setTela("calculadora");
  }, [tutorialAtivo]);
  const [filtroOrc, setFiltroOrc] = useState("aguardando"); // 'aguardando'|'aprovado'|'expirado'
  const [buscaOrc, setBuscaOrc] = useState("");
  const [orcamentoAtualId, setOrcamentoAtualId] = useState(null); // orçamento aberto na tela 'detalhes'
  const [catalogoOrcamento, setCatalogoOrcamento] = useState(null);
  const [ajustarPrecoAberto, setAjustarPrecoAberto] = useState(false); // painel "Ajustar preço" dentro de 'detalhes'
  const [ajusteMargemDigitada, setAjusteMargemAlvo] = useState("50");
  const limiteMargemOrcamento = margemMaxima(resultado.taxaTotalPct);
  const ajusteMargemAlvo = String(limitarMargem(ajusteMargemDigitada, resultado.taxaTotalPct));
  const [aplicandoAjuste, setAplicandoAjuste] = useState(false);
  // Wizard "Novo Orçamento" (tela 'novo-orcamento')
  const [wizardStep, setWizardStep] = useState("cliente"); // 'cliente'|'itens'|'calculo'|'resumo'
  // Etapa "Preço" do wizard: Margem (% sobre a venda) ou Preço manual (R$ do
  // total) — mesmo motor (planejarPrecoOrcamento) resolve os dois, só muda o
  // que o vendedor digita.
  const [wizardModoPreco, setWizardModoPreco] = useState("margem"); // 'margem'|'preco'
  const [wizardPrecoAlvo, setWizardPrecoAlvo] = useState("");
  // Quando o wizard manda pra Calculadora calcular um item novo, guarda que
  // precisa voltar pro wizard (e não ficar na Calculadora) depois de salvar.
  const [voltarParaWizard, setVoltarParaWizard] = useState(false);
  // Histórico de cálculos aplicados (registrar produto / adicionar ao
  // orçamento / ajustar margem em massa)
  const [historico, setHistorico] = useState([]);
  const [carregandoHistorico, setCarregandoHistorico] = useState(false);
  // Anexar arquivo a um item já salvo do orçamento (passo "Itens" do wizard)
  const [anexandoArquivoIdx, setAnexandoArquivoIdx] = useState(null);
  const [anexandoIdxAtual, setAnexandoIdxAtual] = useState(null);
  const arquivoOrcRef = useRef();
  const [fatiando, setFatiando] = useState(false);
  const [coresDetectadas, setCoresDetectadas] = useState(null); // [{colorHex, peso_g, filamentoId}] | null
  // Arquivo enviado pra fatiar/inspecionar, mantido no Storage até o usuário
  // decidir: se registrar o produto, vira o arquivo dele (sem reenviar); se
  // cancelar, é apagado. { storagePath, fileUrl, fileName, thumbnail } | null
  const [arquivoFatiado, setArquivoFatiado] = useState(null);
  const fatiarRef = useRef();
  // Mantém todas as placas e reaproveita o resultado das que já foram fatiadas.
  const [configFatiamento, setConfigFatiamento] = useState(null);
  const impressoraParaFatiar = calculo.impressoraAtual?.modelo?.trim() || calculo.impressoraAtual?.nome?.trim() || "";
  const kobraXSelecionada = /\b(?:anycubic\s+)?(?:kobra|cobra)\s*x\b/i.test(impressoraParaFatiar);
  const selecaoFatiamento = configFatiamento
    ? separarPlacasParaFatiar(configFatiamento.data, configFatiamento.placasEscolhidas,
      resultadoSalvoDaImpressora(configFatiamento.data, impressoraParaFatiar))
    : { salvas: [], pendentes: [] };
  const selecaoJaFatiada = selecaoFatiamento.pendentes.length === 0;
  const [resumoImportacao, setResumoImportacao] = useState(null);
  // "Importar do MakerWorld": link + fotos escolhidas ficam aqui até o produto ser
  // registrado (aí o link é salvo nele e as fotos vão pra galeria). Independe do 3MF.
  // { url, modelId, title, perfilTitulo, perfilUrl, fotosIds, previas } | null
  // `previas`: fotos pequenas (data URL) — undefined = baixando, [] = nenhuma veio.
  // Aparecem na tela, no registro do produto e já entram nas fotos do orçamento.
  const [makerworld, setMakerworld] = useState(null);
  // Qual pop-up de importação está aberto: "completo" (botão da calculadora: perfil +
  // fotos), "produto" (do registro de produto) ou "orcamento" (do item do orçamento) —
  // os dois últimos só trazem link e fotos. `linkParaImportar` é o link que abre preenchido.
  const [makerworldModo, setMakerworldModo] = useState(null);
  const [linkParaImportar, setLinkParaImportar] = useState("");
  // Campo "Link do MakerWorld" do registro de produto (texto livre; vai gravado no produto).
  const [linkMakerworld, setLinkMakerworld] = useState("");
  const [fatiandoSlice, setFatiandoSlice] = useState(false);
  const [progressoFatiamento, setProgressoFatiamento] = useState(null); // {feito, total, pendentes} | null — várias placas somadas
  const [erroFatiamento, setErroFatiamento] = useState(null); // {titulo, explicacao, dica, detalheTecnico} | null — ver utils/erroFatiamento
  // Vários arquivos: a partir do 2º arquivo importado, cada um vira um item com o
  // PRÓPRIO cálculo completo (ver utils/itensArquivo). Só o item ativo vive nos
  // estados de tela (calculo, arquivoFatiado, fotoBase64...); os demais ficam aqui.
  // Com 0 ou 1 arquivo esta lista fica vazia e nada muda na calculadora.
  const [itensArquivo, setItensArquivo] = useState([]);
  const [itemAtivoId, setItemAtivoId] = useState(null);
  const [loteOrc, setLoteOrc] = useState(null); // itens do orçamento em lote (modal "adicionar-orcamento") | null
  const importandoOutroRef = useRef(false); // o arquivo em importação vai virar um item novo (e não substituir o atual)
  const proximoIdItemRef = useRef(1);
  const emLote = itensArquivo.length >= 2;

  // registro de produto — nome/unidades já vêm do núcleo (calculo.nome/calculo.unidades);
  // aqui só o que é específico de arquivo/foto, que o motor de preço não precisa saber.
  const [fotoBase64, setFotoBase64] = useState("");
  const [arquivo3mf, setArquivo3mf] = useState(null);
  const [carregandoFoto, setCarregandoFoto] = useState(false);
  // Fotos escolhidas à mão no registro (arquivo, arrastar ou Ctrl+V), em data URL
  // até 1920 px — sobem pra galeria do produto ao registrar.
  const [fotosRegistro, setFotosRegistro] = useState([]);
  const [carregandoFotosRegistro, setCarregandoFotosRegistro] = useState(false);
  const [registrando, setRegistrando] = useState(false);
  const [categoriasRegistro, setCategoriasRegistro] = useState([]);
  const [categoriasRegistroManual, setCategoriasRegistroManual] = useState(false);
  const [categoriasDisponiveis, setCategoriasDisponiveis] = useState([]);
  const [mostrarCategoriasRegistro, setMostrarCategoriasRegistro] = useState(false);
  useEffect(() => {
    if (modalAberto !== "registrar-produtos" && modalAberto !== "registrar-varios") return;
    let ativo = true;
    fbList("categorias")
      .then(lista => { if (ativo) setCategoriasDisponiveis([...lista].sort((a, b) => (a.nome || "").localeCompare(b.nome || "", "pt-BR", { sensitivity:"base" }))); })
      .catch(() => { if (ativo) toast("Nao foi possivel carregar as categorias.", "error"); });
    return () => { ativo = false; };
  }, [modalAberto]);
  useAvisoAoSair(fatiando || registrando);
  const fotoRef = useRef();
  // Modelo 3D pra exibição (ativa o botão "Ver em 3D" pro cliente) — explícito
  // e separado do arquivo usado pra fatiar/calcular custo (arquivoFatiado/
  // arquivo3mf, acima). Compartilhado entre "Registrar produto" e "Adicionar
  // ao orçamento", igual ao padrão do arquivo de fatiamento.
  const [modelo3dFile, setModelo3dFile] = useState(null);
  const modelo3dRef = useRef();
  const [confirmar, modalConfirm] = useConfirm();

  // orçamento (link temporário pro cliente — não entra no catálogo)
  const [orcForm, setOrcForm] = useState({ nome:"", altura:"", observacoes:"", fotos:[], preco:"", cores:[], quantidade:"1", linkMakerworld:"" });
  const [nomeClienteForm, setNomeClienteForm] = useState(""); // só perguntado ao começar um orçamento novo
  const [clienteSelId, setClienteSelId] = useState(null); // id do cadastro em Clientes escolhido no autocomplete (ou null = vai criar/achar pelo nome ao salvar)
  const [buscaClienteAberto, setBuscaClienteAberto] = useState(false);
  const [editandoOrc, setEditandoOrc] = useState(null); // { id, index } do item em edição no popup, ou null = item novo
  // Item carregado de volta na calculadora pra refazer TUDO (cores, margem,
  // mão de obra, desconto...) — diferente do editandoOrc (edição rápida via popup).
  // Precisa saber o orçamento E o índice do item, pra gravar de volta no lugar certo.
  const [calcCarregado, setCalcCarregado] = useState(null); // { id, index, nomeCliente, nomeItem }
  const [salvandoOrc, setSalvandoOrc] = useState(false);
  const [carregandoFotoOrc, setCarregandoFotoOrc] = useState(false);
  const [orcamentosSalvos, setOrcamentosSalvos] = useState([]);
  const [carregandoOrcamentos, setCarregandoOrcamentos] = useState(false);
  const [gerandoLinkId, setGerandoLinkId] = useState(null);
  const [gerandoPedidoId, setGerandoPedidoId] = useState(null);
  const criandoPedidoRef = useRef(false);
  const [registrandoItemKey, setRegistrandoItemKey] = useState(null); // `${orcId}:${index}`
  // Orçamento "em aberto" — carrinho que vai recebendo itens de "Adicionar ao
  // Orçamento" até você decidir mandar o link. Sobrevive à troca de aba (fica
  // no localStorage) — senão sumia toda vez que você saísse da Calculadora
  // no meio de montar o orçamento de um cliente.
  const [rascunhoId, setRascunhoIdState] = useState(() => {
    try { return localStorage.getItem(RASCUNHO_KEY) || null; } catch { return null; }
  });
  const [rascunho, setRascunho] = useState(null); // { nomeCliente, itens } do orçamento em aberto
  const definirRascunho = (id) => {
    setRascunhoIdState(id);
    try { id ? localStorage.setItem(RASCUNHO_KEY, id) : localStorage.removeItem(RASCUNHO_KEY); } catch {}
  };

  // Clientes + orçamentos salvos — carregado de cara (não só quando abre
  // "Orçamentos") pra dar pra buscar "cliente já tem orçamento aberto?" no
  // popup/wizard de novo orçamento. Cadastro de filamentos/impressoras/
  // materiais já é buscado dentro de useCalculoProduto.
  useEffect(() => {
    const u0 = getUser();
    Promise.all([
      fbList("clientes"),
      fbList("produtos"),
      u0?.uid ? listarOrcamentos(u0.uid) : Promise.resolve([]),
    ]).then(([cli, prods, orcs]) => {
      setClientes(cli);
      setProdutos(prods);
      setOrcamentosSalvos(orcs);
    });
  }, []);

  // O Cloud Run recusa requisições acima de ~32MB — 3MFs de modelos mais
  // detalhados passam disso fácil. Solução: o navegador sobe o arquivo
  // direto no Firebase Storage (sem esse limite) e manda só a URL pro
  // serviço buscar do lado dele. O arquivo fica lá até o usuário registrar
  // o produto (aí vira o arquivo dele, sem reenviar) ou cancelar (aí é
  // apagado).
  const uploadParaFatiar = async (file) => {
    // Se já tinha um arquivo pendente (não usado num produto ainda), apaga
    // antes de subir o novo — evita acumular lixo no Storage. Quando o novo
    // arquivo vira um item à parte, o anterior continua sendo usado.
    if (!importandoOutroRef.current && arquivoFatiado?.storagePath) {
      deleteObject(ref(storage, arquivoFatiado.storagePath)).catch(() => {});
    }
    const u = getUser();
    const storagePath = `slicer_uploads/${u?.uid || "anon"}/${Date.now()}_${file.name}`;
    const fileRef = ref(storage, storagePath);
    await uploadBytes(fileRef, file);
    const fileUrl = await getDownloadURL(fileRef);
    return { fileUrl, storagePath, fileName: file.name };
  };

  // Cruza os filamentos do AMS/projeto com o peso já apurado por posição
  // (índice do slot) e monta a lista pra confirmar em "coresDetectadas" —
  // usado tanto quando o arquivo já veio fatiado (peso de slice_info.config)
  // quanto depois de fatiar agora mesmo (peso da resposta do /slice).
  const detectadosDoArquivo = (materiais, pesos) => filamentosDetectados(materiais, pesos).map(m => ({
    colorHex: m.color || null, peso_g: m.peso_g,
    filamentoId: m.color ? encontrarFilamentoMaisProximo(m.color,
      filamentos.filter(f => !m.type || f.material?.toUpperCase() === m.type.toUpperCase()), coresCustom)?.id || "" : "",
  }));
  const avisoSemFilamentos = () => toast("Não há filamentos com consumo identificado. Confira o total importado e adicione os materiais abaixo.", "warning");
  const preencherFilamentosDetectados = (materiais, pesos) => {
    const detectados = detectadosDoArquivo(materiais, pesos);
    setCoresDetectadas(detectados.length ? detectados : null);
    if (!detectados.length) avisoSemFilamentos();
  };

  // ── Vários arquivos ── estado "de tela" do arquivo ativo <-> item da lista.
  const capturarItemAtivo = (id) => ({
    id, calculo: calculo.capturarCalculo(), arquivoFatiado, fotoBase64, coresDetectadas, resumoImportacao,
  });
  const carregarItemNaTela = (item) => {
    calculo.restaurarCalculo(item.calculo);
    setArquivoFatiado(item.arquivoFatiado); setFotoBase64(item.fotoBase64);
    setCoresDetectadas(item.coresDetectadas); setResumoImportacao(item.resumoImportacao);
    setArquivo3mf(null);
  };
  // Itens com o ativo atualizado pelo que está na tela agora (quem edita é a tela).
  const itensAtualizados = () => itensArquivo.map(i => i.id === itemAtivoId ? capturarItemAtivo(i.id) : i);

  // Já existe um arquivo e chegou outro: o novo vira um item ativo, com o próprio
  // cálculo; o anterior guarda o dele (filamentos, preço...) como está.
  const adicionarItemArquivo = ({ registro, horas, resumo, detectados }) => {
    let base;
    if (itensArquivo.length) base = itensAtualizados();
    else {
      const primeiro = capturarItemAtivo(proximoIdItemRef.current++);
      if (!primeiro.calculo.nome.trim()) primeiro.calculo = { ...primeiro.calculo, nome: nomeDoArquivo(primeiro.arquivoFatiado?.fileName) };
      base = [primeiro];
      setItemAtivoId(primeiro.id);
    }
    const novo = {
      id: proximoIdItemRef.current++,
      calculo: calculoDoNovoItem(calculo.capturarCalculo(), { nome: nomeDoArquivo(registro.fileName), horas }),
      arquivoFatiado: registro, fotoBase64: registro.thumbnail || "",
      coresDetectadas: detectados.length ? detectados : null, resumoImportacao: resumo,
    };
    setItensArquivo([...base, novo]);
    setItemAtivoId(novo.id);
    carregarItemNaTela(novo);
    if (horas == null) toast("O arquivo não informa o tempo de todas as placas selecionadas. Preencha o tempo do Bambu Studio.", "warning");
    if (!detectados.length) avisoSemFilamentos();
    else toast(`✅ "${novo.calculo.nome}" adicionado — cada arquivo tem o próprio cálculo e preço.`, "success");
  };

  const selecionarItemArquivo = (id) => {
    const alvo = itensArquivo.find(i => i.id === id);
    if (!alvo || id === itemAtivoId) return;
    setItensArquivo(itensAtualizados());
    setItemAtivoId(id);
    carregarItemNaTela(alvo);
  };

  // Tira itens do lote (removidos ou já salvos). Sobrando menos de 2, volta ao
  // modo de um arquivo só. `apagarArquivos`: remove do Storage o arquivo temporário.
  const retirarItensDoLote = (ids, apagarArquivos) => {
    const lista = itensAtualizados();
    if (apagarArquivos) lista.filter(i => ids.includes(i.id)).forEach(i => {
      if (i.arquivoFatiado?.storagePath) deleteObject(ref(storage, i.arquivoFatiado.storagePath)).catch(() => {});
    });
    const { restantes, ativoId, encerrarLote } = depoisDeRemover(lista, ids, itemAtivoId);
    setItensArquivo(encerrarLote ? [] : restantes);
    setItemAtivoId(encerrarLote ? null : ativoId);
    const novoAtivo = restantes.find(i => i.id === ativoId);
    if (novoAtivo && (encerrarLote || ids.includes(itemAtivoId))) carregarItemNaTela(novoAtivo);
    setLoteOrc(atual => atual ? atual.filter(l => !ids.includes(l.id)) : atual);
  };
  const removerItemArquivo = async (id) => {
    const alvo = itensAtualizados().find(i => i.id === id);
    if (!alvo || !await confirmar(`Remover "${nomeDoItem(alvo)}" deste cálculo?`)) return;
    retirarItensDoLote([id], true);
  };

  const aplicarResultadoImportado = (data, placas, fonte, registro) => {
    const resumo = resumirPlacas(placas);
    const placasSelecionadas = placasFatiadasDoResultado(placas);
    const resumoImportacao = {
      ...resumo, fonte, placas: placas.map(p => p.index),
      impressora: data.printer?.profile || data.printer?.model || "Não informada no arquivo",
    };
    if (importandoOutroRef.current) {
      adicionarItemArquivo({ registro: { ...registro, placasSelecionadas }, horas: resumo.horas, resumo: resumoImportacao,
        detectados: detectadosDoArquivo(materiaisDoResultado(data), resumo.pesos) });
      return;
    }
    setArquivoFatiado(atual => atual ? { ...atual, placasSelecionadas } : atual);
    calculo.setHoras(resumo.horas == null ? "" : String(resumo.horas));
    preencherFilamentosDetectados(materiaisDoResultado(data), resumo.pesos);
    setResumoImportacao(resumoImportacao);
    if (resumo.horas == null) toast("O arquivo não informa o tempo de todas as placas selecionadas. Preencha o tempo do Bambu Studio.", "warning");
  };

  // Desistiu da importação (fechou/cancelou): o arquivo que ia virar um item
  // novo não fica esquecido no Storage.
  const cancelarConfigFatiamento = () => {
    if (importandoOutroRef.current && configFatiamento?.registro?.storagePath) {
      deleteObject(ref(storage, configFatiamento.registro.storagePath)).catch(() => {});
    }
    setConfigFatiamento(null);
  };

  // Erro ao ler ou fatiar: o arquivo sai da calculadora e do Storage, em vez
  // de ficar como o arquivo atual sem resultado.
  const descartarArquivoComErro = (registro) => {
    deleteObject(ref(storage, registro.storagePath)).catch(() => {});
    if (!importandoOutroRef.current) {
      setArquivoFatiado(atual => atual?.storagePath === registro.storagePath ? null : atual);
      if (registro.thumbnail) setFotoBase64(atual => atual === registro.thumbnail ? "" : atual);
    }
    setConfigFatiamento(null);
  };

  const handleInspecionar3mf = async (file) => {
    const { fileUrl, storagePath, fileName } = await uploadParaFatiar(file);
    let registro = { storagePath };
    try {
      const res = await fetchFatiador(INSPECT_URL, {
        method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${await auth.currentUser?.getIdToken()}` },
        body: JSON.stringify({ fileUrl, originalName: file.name }),
      }, 3 * 60000);
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Falha ao ler o arquivo");
      registro = { storagePath, fileUrl, fileName, thumbnail: data.thumbnail || null };
      // Outro arquivo (2º em diante) só vira o "atual" depois de importado, como item à parte.
      if (!importandoOutroRef.current) {
        setArquivoFatiado(registro);
        setFotoBase64(data.thumbnail || "");
      }
      const previews = await extrairPlacas3mf(file);
      const placas = listarPlacasImportacao(data, previews);
      const { salvas, pendentes } = separarPlacasParaFatiar(data, placas.map(p => p.indice), resultadoSalvoDaImpressora(data, impressoraParaFatiar));
      if (placas.length === 1 && pendentes.length === 0) {
        aplicarResultadoImportado(data, salvas, "Resultado salvo no arquivo", registro);
        return;
      }
      setConfigFatiamento({
        fileUrl, storagePath, fileName, data, materiais: materiaisDoResultado(data), placas,
        placasEscolhidas: placas.map(p => p.indice), registro,
      });
    } catch (e) {
      descartarArquivoComErro(registro);
      throw e;
    }
  };

  const confirmarConfigFatiamento = async () => {
    if (!configFatiamento) return;
    const selecionadas = configFatiamento.placasEscolhidas;
    if (!selecionadas.length) { toast("Selecione pelo menos uma placa.", "warning"); return; }
    const { salvas, pendentes } = separarPlacasParaFatiar(configFatiamento.data, selecionadas,
      resultadoSalvoDaImpressora(configFatiamento.data, impressoraParaFatiar));
    if (!pendentes.length) {
      aplicarResultadoImportado(configFatiamento.data, salvas, "Resultado salvo no arquivo", configFatiamento.registro);
      setConfigFatiamento(null);
      return;
    }
    if (!impressoraParaFatiar) { toast("Selecione a impressora na calculadora antes de fatiar.", "warning"); return; }
    setFatiandoSlice(true);
    setProgressoFatiamento({ feito: 0, total: pendentes.length, pendentes });
    try {
      const health = await fetchFatiador(`${SLICER_BASE}/health`, {}, 20000);
      const capabilities = await health.json();
      if (!health.ok || capabilities.apiVersion !== 3 || capabilities.settingsMode !== "app-printer" || capabilities.printerSelection !== true) {
        throw new Error("O serviço online precisa ser atualizado. Enquanto isso, importe a placa já fatiada pelo Bambu Studio.");
      }
      if (kobraXSelecionada && !capabilities.anycubicKobraX) {
        throw new Error("O fatiador Anycubic para Kobra X ainda nao esta disponivel neste servidor.");
      }
      if (!kobraXSelecionada && !capabilities.ready) {
        throw new Error("O fatiador Bambu Studio não está disponível neste servidor.");
      }
      const placas = [...salvas];
      const fontes = new Set(salvas.length ? ["Resultados salvos"] : []);
      const perfis = new Set(salvas.length ? [configFatiamento.data.printer?.profile || configFatiamento.data.printer?.model || "Perfil do arquivo"] : []);
      for (const [i, plateIndex] of pendentes.entries()) {
        // Kobra X pode tentar o projeto direto e depois o perfil oficial, até 10 min cada.
        const res = await fetchFatiador(SLICE_URL, {
          method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${await auth.currentUser?.getIdToken()}` },
          body: JSON.stringify({ fileUrl: configFatiamento.fileUrl,
            originalName: configFatiamento.fileName, plateIndex, printerModel: impressoraParaFatiar }),
        }, 25 * 60000);
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Falha ao fatiar o arquivo");
        if (data.apiVersion !== 3 || !(data.settingsPreserved === true || (kobraXSelecionada && data.geometryPreserved === true && data.settingsMode === "kobra-profile")) || !Number.isFinite(data.horas) || data.horas <= 0) {
          throw new Error("O serviço não retornou um resultado válido com as configurações do projeto.");
        }
        fontes.add(data.source === "saved-slice" ? "Resultados salvos" : data.engine || capabilities.engine || "Fatiamento online");
        perfis.add(data.perfil?.profile || data.perfil?.model || impressoraParaFatiar);
        placas.push({ index: plateIndex, predictionSeconds: data.horas * 3600, weightG: data.peso_g,
          filaments: (data.filamentos || []).map(f => ({ id: f.id, usedG: f.peso_g, color: f.color, type: f.type })) });
        setProgressoFatiamento({ feito: i + 1, total: pendentes.length, pendentes });
      }
      placas.sort((a, b) => a.index - b.index);
      aplicarResultadoImportado({ ...configFatiamento.data, sliceResult: placas,
        printer: { ...configFatiamento.data.printer, model: impressoraParaFatiar, profile: [...perfis].join(" / ") } }, placas,
        [...fontes].join(" + "), configFatiamento.registro);
      setConfigFatiamento(null);
    } catch (e) {
      console.error("Erro ao fatiar:", e.message);
      setErroFatiamento(traduzirErroFatiamento(e.message));
      descartarArquivoComErro(configFatiamento.registro);
    } finally {
      setFatiandoSlice(false);
      setProgressoFatiamento(null);
    }
  };

  const handleFatiar = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const nome = file.name.toLowerCase();
    if (!nome.endsWith(".3mf") && !nome.endsWith(".gcode")) {
      toast("Envie um arquivo .3mf ou .gcode.", "warning");
      return;
    }

    setFatiando(true);
    setArquivo3mf(null);
    // A partir do 2º arquivo, o novo vira um item à parte (com o próprio cálculo)
    // em vez de apagar o anterior. Só conta um arquivo já IMPORTADO (resumoImportacao):
    // um que foi aberto mas cujo modal de placas foi cancelado continua sendo substituído.
    // Editando um item salvo, também continua substituindo.
    importandoOutroRef.current = !calcCarregado && (!!resumoImportacao || itensArquivo.length > 0);
    if (!importandoOutroRef.current) {
      setCoresDetectadas(null);
      setResumoImportacao(null);
      calculo.setHoras("");
    }
    setConfigFatiamento(null);
    try {
      // Todo .3mf é um ZIP ("PK" nos primeiros bytes) — inclusive quando o
      // Bambu Studio exporta o resultado já fatiado com extensão ".gcode".
      // Um .gcode DE VERDADE (texto puro) nunca começa assim.
      const cabecalho = new Uint8Array(await file.slice(0, 2).arrayBuffer());
      const ehZip = cabecalho.length >= 2 && cabecalho[0] === 0x50 && cabecalho[1] === 0x4b;

      if (ehZip) {
        await handleInspecionar3mf(file);
      } else {
        // .gcode de texto puro: já fatiado por definição — só lê os
        // comentários que o fatiador deixou, nunca fatia nada de novo.
        const { fileUrl, storagePath, fileName } = await uploadParaFatiar(file);
        const meta = await extrairMetaGcodeDeArquivo(file);
        const registro = { storagePath, fileUrl, fileName, thumbnail: null };
        const resumoGcode = { fonte: "Resultado salvo no G-code", placas: [1], horas: meta.horas,
          pesoTotal: meta.peso_g, impressora: meta.printerProfile || "Não informada no arquivo" };
        if (importandoOutroRef.current) {
          adicionarItemArquivo({ registro, horas: meta.horas, resumo: resumoGcode,
            detectados: detectadosDoArquivo(meta.materiais || [], meta.pesos || {}) });
        } else {
          setArquivoFatiado(registro);
          setFotoBase64("");
          calculo.setHoras(meta.horas == null ? "" : String(meta.horas));
          preencherFilamentosDetectados(meta.materiais || [], meta.pesos || {});
          setResumoImportacao(resumoGcode);
        }
        toast(
          meta.horas != null
            ? `✅ Tempo lido do g-code: ${meta.horas}h${meta.peso_g != null ? ` · ${meta.peso_g}g no total (selecione o filamento e informe o peso)` : ""}.`
            : "Não encontrei tempo/peso nos comentários desse g-code — preencha manualmente.",
          meta.horas != null ? "success" : "warning"
        );
      }
    } catch (err) {
      toast("Erro: " + err.message, "error");
    }
    setFatiando(false);
  };

  // Abre o pop-up de importação do MakerWorld no modo pedido, já com o link do campo.
  const abrirMakerWorld = (modo, link = "") => { setLinkParaImportar((link || "").trim()); setMakerworldModo(modo); };

  // Fotos pequenas (data URL): prévia na tela/registro e fotos do item do orçamento.
  const carregarPreviasMakerWorld = async (url, fotosIds) => {
    const ids = fotosIds.slice(0, LIMITE_FOTOS_ORCAMENTO);
    let previas = [];
    if (ids.length) {
      try { previas = (await miniaturasFotosMakerWorld({ url, ids })).importadas.map(f => f.url); }
      catch (e) { toast("Não consegui trazer as fotos do MakerWorld pra prévia e o orçamento: " + e.message, "warning"); }
    }
    setMakerworld(atual => atual && atual.url === url ? { ...atual, previas } : atual);
  };

  // "Importar do MakerWorld" (botão da calculadora): preenche tempo e filamentos
  // com os dados do perfil escolhido pelo MESMO caminho do 3MF (placas -> resumo ->
  // cores detectadas, que ainda passam pela conferência de filamento) e guarda
  // link + fotos pro produto. O arquivo 3MF em si não vem (o MakerWorld exige login
  // pra baixar): importar um 3MF depois substitui tempo/cores, mas link e fotos continuam.
  const aplicarMakerWorld = ({ modelo, perfil, placas, fotosIds }) => {
    setLinkMakerworld(modelo.sourceUrl);
    setMakerworld({ url: modelo.sourceUrl, modelId: modelo.modelId, title: modelo.title,
      perfilTitulo: perfil?.titulo || null, perfilUrl: perfil?.urlPagina || null, fotosIds, previas: fotosIds.length ? undefined : [] });
    carregarPreviasMakerWorld(modelo.sourceUrl, fotosIds);
    if (!calculo.nome.trim()) calculo.setNome(modelo.title);
    if (perfil && placas.length) {
      const resumo = resumirPlacas(placas);
      calculo.setHoras(resumo.horas == null ? "" : String(resumo.horas));
      preencherFilamentosDetectados(materiaisDoResultado({ sliceResult: placas }), resumo.pesos);
      setResumoImportacao({ ...resumo, fonte: `MakerWorld — ${perfil.titulo}`, placas: placas.map(p => p.index),
        impressora: "Dados do perfil publicado no MakerWorld" });
      if (resumo.horas == null) toast("O perfil não informa o tempo de todas as placas. Preencha o tempo manualmente.", "warning");
    }
    toast(`✅ "${modelo.title}" importado do MakerWorld${fotosIds.length ? ` — ${fotosIds.length} foto(s) irão pro produto ao registrar` : ""}.`, "success");
  };

  // Registro de produto: guarda o link no campo e as fotos escolhidas pra irem pra
  // galeria ao registrar. Não mexe em tempo, filamentos nem nome do cálculo.
  const aplicarFotosMakerWorldNoProduto = ({ modelo, fotosIds }) => {
    const url = modelo.sourceUrl;
    setLinkMakerworld(url);
    setMakerworld(atual => ({ url, modelId: modelo.modelId, title: modelo.title,
      perfilTitulo: atual?.url === url ? atual.perfilTitulo : null, perfilUrl: atual?.url === url ? atual.perfilUrl : null,
      fotosIds, previas: fotosIds.length ? undefined : [] }));
    carregarPreviasMakerWorld(url, fotosIds);
    toast(`✅ Link salvo${fotosIds.length ? ` — ${fotosIds.length} foto(s) irão pra galeria do produto ao registrar` : ""}.`, "success");
  };

  // Item do orçamento: guarda o link no item e já põe as fotos (miniaturas, até
  // LIMITE_FOTOS_ORCAMENTO) junto das que ele já tem — dá pra tirar/trocar depois.
  // Foto que já está no item (ex.: veio do "Importar do MakerWorld" da calculadora)
  // não entra de novo: a miniatura da mesma foto sai igual, então compara a data URL.
  const aplicarFotosMakerWorldNoOrcamento = async ({ modelo, fotosIds }) => {
    const url = modelo.sourceUrl;
    setOrcForm(f => ({ ...f, linkMakerworld: url }));
    if (!fotosIds.length) { toast("✅ Link salvo no item.", "success"); return; }
    setCarregandoFotoOrc(true);
    try {
      const r = await miniaturasFotosMakerWorld({ url, ids: fotosIds.slice(0, LIMITE_FOTOS_ORCAMENTO) });
      const novas = r.importadas.map(f => f.url).filter(foto => !orcForm.fotos.includes(foto));
      setOrcForm(f => ({ ...f, fotos: [...new Set([...f.fotos, ...novas])] }));
      toast(novas.length
        ? `✅ ${novas.length} foto(s) do MakerWorld no item${fotosIds.length > LIMITE_FOTOS_ORCAMENTO ? ` (o orçamento leva até ${LIMITE_FOTOS_ORCAMENTO})` : ""}.`
        : "As fotos desse link já estão no item.", "success");
    } catch (e) { toast("O link foi salvo, mas não consegui trazer as fotos: " + e.message, "warning"); }
    setCarregandoFotoOrc(false);
  };

  // Destino da importação conforme o pop-up de onde ela foi aberta.
  const confirmarMakerWorld = (dados) => {
    const modo = makerworldModo;
    setMakerworldModo(null);
    if (modo === "completo") aplicarMakerWorld(dados);
    else if (modo === "produto") aplicarFotosMakerWorldNoProduto(dados);
    else if (modo === "orcamento") aplicarFotosMakerWorldNoOrcamento(dados);
  };

  // Adiciona de uma vez todos os filamentos confirmados na conferência de cores.
  const adicionarCoresDetectadas = () => {
    if (coresDetectadas.some(cd => !cd.filamentoId)) {
      toast("Selecione um filamento pra cada cor antes de adicionar!", "warning");
      return;
    }
    if (coresDetectadas.some(cd => !(parseFloat(cd.peso_g) > 0))) {
      toast("Informe o peso (g) de cada cor antes de adicionar!", "warning");
      return;
    }
    calculo.adicionarFilamentosEmLote(coresDetectadas.map(cd => ({ filamentoId: cd.filamentoId, pesoG: cd.peso_g })));
    setCoresDetectadas(null);
    toast("✅ Filamentos das cores adicionados!", "success");
  };

  const handleFoto = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".3mf")) {
      toast("Envie um arquivo .3mf!", "warning");
      e.target.value = "";
      return;
    }
    setCarregandoFoto(true);
    if (arquivoFatiado?.storagePath) deleteObject(ref(storage, arquivoFatiado.storagePath)).catch(() => {});
    setArquivoFatiado(null);
    setResumoImportacao(null);
    setConfigFatiamento(null);
    setArquivo3mf(file);
    const base64 = await extrairFoto3mf(file);
    if (base64) setFotoBase64(base64);
    setCarregandoFoto(false);
    e.target.value = "";
  };

  const handleModelo3d = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!/\.(3mf|stl|obj)$/i.test(file.name)) {
      toast("Envie um arquivo .3mf, .stl ou .obj!", "warning");
      e.target.value = "";
      return;
    }
    setModelo3dFile(file);
    e.target.value = "";
  };

  // Volta a calculadora pro estado inicial — chamado depois de registrar um
  // produto ou adicionar um item ao orçamento, pra não precisar apagar tudo
  // na mão antes de começar o próximo cálculo.
  const resetCalculadora = () => {
    calculo.resetCalculo();
    setCoresDetectadas(null); setResumoImportacao(null); setConfigFatiamento(null); setMakerworld(null); setLinkMakerworld("");
    setFotoBase64(""); setArquivo3mf(null); setArquivoFatiado(null); setCalcCarregado(null);
    setModelo3dFile(null); setFotosRegistro([]);
    setItensArquivo([]); setItemAtivoId(null); setLoteOrc(null);
  };

  // Cria o produto no catálogo (foto, arquivo 3MF e modelo 3D incluídos) a partir
  // dos dados de UM cálculo — serve ao produto único e a cada arquivo de um lote.
  // `snap` é o estado do cálculo (calculo.capturarCalculo) e `res` o resultado dele.
  const criarProduto = async ({ nome, snap, res, uns, categorias, categoriaManual, foto: fotoProduto, fotos: fotosManuais = [], arqFatiado, arq3mf, modelo3d, makerworld: mw, linkMakerworld: link }) => {
    const imp = impressoras.find(i => i.id === snap.impressoraId);
    const docRef = await fbAdd("produtos", {
      nome,
      categorias,
      categoria: categorias[0] || null,
      categoria_manual: categoriaManual,
      categoria_auto: !categoriaManual && categorias.length > 0,
      preco: parseFloat((res.precoFinal / uns).toFixed(2)),
      custo_total: parseFloat((res.custoTotal / uns).toFixed(2)),
      // Compat histórica: continua no "estilo markup" (lucro/custo×100) —
      // quem já lê esse campo (ex.: troca de impressora em Produtos)
      // espera essa convenção. A margem de verdade (lucro/preço) vai no
      // campo novo margem_pct, junto com markup explícito.
      margem: res.custoTotal > 0 ? ((res.precoFinal - res.custoTotal) / res.custoTotal) * 100 : 0,
      margem_pct: res.margemReal,
      markup: res.markup,
      estoque: 0,
      unidades: uns,
      // Produto nasce fora do site — só entra quando escolhido em
      // "Adicionar produtos" na aba Site (evita publicar sem querer).
      ativo: false,
      fotoBase64: fotoProduto || null,
      horas_impressao: arredondarHoras(parseFloat(snap.horas)) || null,
      impressora_id: snap.impressoraId || null,
      impressora_nome: imp?.nome || null,
      mao_obra_hrs: parseFloat(snap.maoObraHrs) || null,
      mao_obra_valor_hr: parseFloat(snap.maoObraValorHr) || null,
      filamentos_usados: snap.filamentosCalc.map(f => ({
        ...f,
        peso: parseFloat((f.peso / uns).toFixed(2)),
        custo_total: parseFloat((f.custo_total / uns).toFixed(2)),
      })),
      materiais_usados: snap.materiaisCalc,
      custos_adicionais: snap.custosAdicionais,
      taxas_usadas: snap.taxas,
      // Link do MakerWorld: o do campo (digitado ou vindo de "Importar do link") — fica
      // gravado no produto mesmo sem importar foto nenhuma.
      ...(link ? { link_makerworld: link } : {}),
      ...(mw?.title && link && mw.url === link ? { makerworld_titulo: mw.title } : {}),
    });

    // Fotos escolhidas à mão no registro: sobem pra galeria primeiro (a 1ª vira capa).
    const galeria = [];
    if (docRef?.id) {
      for (let i = 0; i < fotosManuais.length; i++) {
        const foto = await salvarFotoBase64NoStorage(docRef.id, fotosManuais[i], `foto-${i + 1}`);
        if (foto) galeria.push(foto);
      }
      if (galeria.length < fotosManuais.length) toast(`${fotosManuais.length - galeria.length} foto(s) não puderam ser enviadas.`, "warning");
    }

    // Fotos escolhidas no MakerWorld: o backend baixa e grava direto na galeria
    // do produto (Storage). Falhar aqui não desfaz o produto — só avisa.
    if (mw?.fotosIds?.length && docRef?.id) {
      try {
        const r = await importarFotosMakerWorld({ url: mw.url, ids: mw.fotosIds.slice(0, LIMITE_FOTOS_PRODUTO), produtoId: docRef.id });
        galeria.push(...r.importadas.map(({ path, url }) => ({ path, url })));
        if (r.falhas.length) toast(`${r.falhas.length} foto(s) do MakerWorld não puderam ser importadas.`, "warning");
      } catch (e) { toast("Produto criado, mas as fotos do MakerWorld não foram importadas: " + e.message, "warning"); }
    }
    if (galeria.length) await fbUpdate("produtos", docRef.id, { fotos: galeria, fotoBase64: galeria[0].url }).catch(() => {});

    // Semeia a galeria (Storage) com essa foto inicial — sem isso o produto
    // nasce só com fotoBase64 "solta" (fora do array), igual aos produtos
    // antigos de antes da galeria existir. Com fotos escolhidas a galeria já
    // está montada (e é melhor que o thumbnail do 3MF), então não semeia.
    if (fotoProduto && docRef?.id && !galeria.length) {
      const foto = await salvarFotoBase64NoStorage(docRef.id, fotoProduto, "foto-principal");
      if (foto) await fbUpdate("produtos", docRef.id, { fotos: [foto] }).catch(() => {});
    }

    // Arquivo do produto: se já tinha sido enviado pelo botão "Fatiar", ele
    // está em slicer_uploads/ — uma pasta temporária com regra de ciclo de
    // vida que APAGA tudo depois de 2 dias. Precisa copiar pro caminho
    // definitivo do produto aqui, senão o arquivo some sozinho depois de
    // registrado (e a referência no Firestore fica quebrada pra sempre).
    // Junta num array só (em vez de writes separados) porque o modelo 3D de
    // exibição, abaixo, pode coexistir com o arquivo de fatiamento.
    const arquivosProduto = [];
    let visualizacao3dProduto = null;
    if (arqFatiado && docRef?.id) {
      try {
        const resp = await fetch(arqFatiado.fileUrl);
        const blob = await resp.blob();
        const path = `produtos/${docRef.id}/${Date.now()}_${arqFatiado.fileName}`;
        const storageRef = ref(storage, path);
        await uploadBytes(storageRef, blob);
        const url = await getDownloadURL(storageRef);
        const arquivo = await prepararArquivo3d(blob, { nome: arqFatiado.fileName, path, url }, arqFatiado);
        arquivosProduto.push(arquivo);
        deleteObject(ref(storage, arqFatiado.storagePath)).catch(() => {});
      } catch {}
    } else if (arq3mf && docRef?.id) {
      try {
        const path = `produtos/${docRef.id}/${Date.now()}_${arq3mf.name}`;
        const storageRef = ref(storage, path);
        await uploadBytes(storageRef, arq3mf);
        const url = await getDownloadURL(storageRef);
        const arquivo = await prepararArquivo3d(arq3mf, { nome: arq3mf.name, path, url });
        arquivosProduto.push(arquivo);
      } catch {}
    }
    if (modelo3d && docRef?.id) {
      try {
        const { arquivo, visualizacao3d } = await prepararModelo3dExibicao(`produtos/${docRef.id}`, modelo3d);
        arquivosProduto.push(arquivo);
        visualizacao3dProduto = visualizacao3d;
      } catch {}
    }
    if (arquivosProduto.length && docRef?.id) {
      await fbUpdate("produtos", docRef.id, {
        arquivos: arquivosProduto,
        ...(visualizacao3dProduto ? { visualizacao3d: visualizacao3dProduto } : {}),
      }).catch(() => {});
    }
    return docRef;
  };

  const registrarProduto = async () => {
    if (!calculo.nome.trim()) { toast("Informe o nome do produto!", "warning"); return; }
    const linkProduto = linkMakerworld.trim();
    if (linkProduto && !/^https?:\/\/\S+$/i.test(linkProduto)) { toast("O link do MakerWorld precisa começar com https://", "warning"); return; }
    // Arquivo não é mais obrigatório — só confirma se a pessoa realmente
    // quer seguir sem ele. Ambos os caminhos de anexar contam — "📤 Carregar
    // 3MF" (arquivoFatiado) ou "📎 Selecionar .3mf" aqui no popup (arquivo3mf).
    if (!arquivoFatiado && !arquivo3mf) {
      if (!await confirmar("Tem certeza que vai salvar sem o arquivo (.3mf)?")) return;
    }
    setRegistrando(true);
    try {
      const categoriasSalvas = categoriasRegistroManual ? categoriasRegistro : sugerirCategoriasProduto(calculo.nome, categoriasDisponiveis);
      await criarProduto({
        nome: calculo.nome.trim(), snap: calculo.capturarCalculo(), res: resultado, uns: calculo.uns,
        categorias: categoriasSalvas, categoriaManual: categoriasRegistroManual, foto: fotoBase64, fotos: fotosRegistro,
        arqFatiado: arquivoFatiado, arq3mf: arquivo3mf, modelo3d: modelo3dFile, makerworld, linkMakerworld: linkProduto,
      });

      toast(`Produto "${calculo.nome.trim()}" registrado!`, "success");
      const u = getUser();
      if (u?.uid) {
        const custosAdicionaisTotal = resultado.detalhamento.filter(d=>d.categoria==="adicional").reduce((s,d)=>s+d.valor,0);
        salvarHistoricoCalculo(u.uid, { ...resultado, custosAdicionaisTotal, origem:"produto" });
      }
      setCategoriasRegistro([]);
      setCategoriasRegistroManual(false);
      setMostrarCategoriasRegistro(false);
      resetCalculadora(); // não apaga o arquivoFatiado do Storage — já foi "entregue" pro produto
      setModalAberto(null);
    } catch (e) {
      toast("Erro ao registrar: " + e.message, "error");
    }
    setRegistrando(false);
  };

  // Vários arquivos: cada um vira um produto próprio, com o nome, as unidades e o
  // preço do seu cálculo. Se algum falhar, os já registrados saem do lote para não
  // duplicar ao tentar de novo.
  const registrarProdutosLote = async () => {
    const itens = itensAtualizados();
    setRegistrando(true);
    const registrados = [];
    try {
      const u = getUser();
      for (const it of itens) {
        const res = calcularResultado(it.calculo);
        const nome = nomeDoItem(it);
        await criarProduto({
          nome, snap: it.calculo, res, uns: unidadesDoItem(it.calculo),
          categorias: sugerirCategoriasProduto(nome, categoriasDisponiveis), categoriaManual: false,
          foto: it.fotoBase64, arqFatiado: it.arquivoFatiado, arq3mf: null, modelo3d: null,
        });
        registrados.push(it.id);
        if (u?.uid) {
          const custosAdicionaisTotal = res.detalhamento.filter(d=>d.categoria==="adicional").reduce((s,d)=>s+d.valor,0);
          salvarHistoricoCalculo(u.uid, { ...res, custosAdicionaisTotal, origem:"produto" });
        }
      }
      toast(`✅ ${itens.length} produtos registrados!`, "success");
      resetCalculadora(); // os arquivos já foram "entregues" aos produtos
      setModalAberto(null);
    } catch (e) {
      toast(`Erro ao registrar: ${e.message}${registrados.length ? ` — ${registrados.length} de ${itens.length} já foram registrados e saíram da lista.` : ""}`, "error");
      if (registrados.length) retirarItensDoLote(registrados, false);
    }
    setRegistrando(false);
  };

  // Fecha o popup de registrar sem salvar — se tinha um arquivo fatiado
  // pendente (ainda não "entregue" a nenhum produto), apaga do Storage.
  const cancelarRegistro = () => {
    if (arquivoFatiado?.storagePath) {
      deleteObject(ref(storage, arquivoFatiado.storagePath)).catch(() => {});
      setArquivoFatiado(null);
    }
    setCategoriasRegistro([]);
    setCategoriasRegistroManual(false);
    setMostrarCategoriasRegistro(false);
    setModalAberto(null);
  };

  // ── Orçamento (foto + preço + altura + observações + cores, sem peso/custo) ──
  // Fica em base64 mesmo (não migra pro Storage) — orçamento é temporário e expira em 14 dias.
  const [lightboxOrcIdx, setLightboxOrcIdx] = useState(null);
  const adicionarFotosOrc = async (files) => {
    setCarregandoFotoOrc(true);
    const novas = [];
    for (const file of files) {
      const base64 = await imagemParaBase64(file);
      if (base64) novas.push(base64);
    }
    if (novas.length > 0) setOrcForm(f => ({ ...f, fotos:[...f.fotos, ...novas] }));
    setCarregandoFotoOrc(false);
  };
  const removerFotoOrc = (i) => setOrcForm(f => ({ ...f, fotos:f.fotos.filter((_,fi)=>fi!==i) }));
  const adicionarFotosRegistro = async (files) => {
    setCarregandoFotosRegistro(true);
    const novas = (await Promise.all([...files].map(file => imagemParaBase64(file, 1920)))).filter(Boolean);
    setFotosRegistro(f => [...f, ...novas]);
    setCarregandoFotosRegistro(false);
  };

  // Recarrega o orçamento em aberto (pro indicador no topo da tela) — aceita
  // um id explícito porque logo depois de criar um orçamento novo o estado
  // `rascunhoId` ainda não foi re-renderizado nesta mesma função.
  const atualizarRascunho = async (idParam) => {
    const u = getUser();
    const id = idParam ?? rascunhoId;
    if (!u?.uid || !id) { setRascunho(null); return; }
    try {
      const o = await getOrcamento(u.uid, id);
      if (!o) { definirRascunho(null); setRascunho(null); return; } // foi excluído em outro lugar
      setRascunho(o);
    } catch {}
  };
  useEffect(() => { atualizarRascunho(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // Carrega a lista de orçamentos já na entrada da Calculadora (não só quando
  // a pessoa visita "Meus orçamentos") — sem isso, encontrarOrcamentoAtivoDoCliente
  // não teria como achar o orçamento ativo de um cliente na primeira visita.
  useEffect(() => { abrirListaOrcamentos(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const encerrarRascunho = () => { definirRascunho(null); setRascunho(null); };

  // Abre o popup pra adicionar o cálculo atual como item no orçamento em
  // aberto — ou começar um orçamento novo (pede o nome do cliente) se não
  // tiver nenhum em aberto ainda.
  const abrirNovoOrcamento = () => {
    const cores = calculo.filamentosCalc.map(f => ({ nome:f.nome, material:f.material, hex:corFilamentoHex(f.nome, coresCustom) }));
    const precoInicial = resultado.precoFinal / calculo.uns;
    // Fotos escolhidas em "Importar do MakerWorld" já vêm no item (dá pra tirar/trocar).
    setOrcForm({ nome:calculo.nome.trim(), altura:"", observacoes:"", fotos:makerworld?.previas || [], preco:precoInicial.toFixed(2), cores, quantidade:"1",
      linkMakerworld: linkMakerworld.trim() || makerworld?.url || "" });
    setNomeClienteForm(rascunho?.nomeCliente || nomeClienteForm || "");
    setClienteSelId(rascunho ? (rascunho.clienteId || null) : clienteSelId);
    setEditandoOrc(null);
    setPassoAdicionar("produto");
    setModalAberto("adicionar-orcamento");
  };

  // As fotos do MakerWorld podem terminar de baixar DEPOIS de o formulário do
  // orçamento já estar aberto (item novo, ainda sem fotos): entram quando chegam.
  useEffect(() => {
    const previas = makerworld?.previas;
    if (!previas?.length || modalAberto !== "adicionar-orcamento" || editandoOrc || loteOrc) return;
    setOrcForm(f => f.fotos.length ? f : { ...f, fotos: previas });
  }, [makerworld?.previas]); // eslint-disable-line react-hooks/exhaustive-deps

  // Vários arquivos: abre o mesmo popup, com um produto por arquivo (nome, preço
  // por unidade e quantidade de cada um, já vindos do cálculo de cada aba).
  const abrirNovoOrcamentoLote = () => {
    setLoteOrc(itensAtualizados().map(it => {
      const res = calcularResultado(it.calculo);
      return {
        id: it.id, nome: nomeDoItem(it), quantidade: "1",
        preco: (res.precoFinal / unidadesDoItem(it.calculo)).toFixed(2),
        cores: it.calculo.filamentosCalc.map(f => ({ nome:f.nome, material:f.material, hex:corFilamentoHex(f.nome, coresCustom) })),
      };
    }));
    setNomeClienteForm(rascunho?.nomeCliente || nomeClienteForm || "");
    setClienteSelId(rascunho ? (rascunho.clienteId || null) : clienteSelId);
    setEditandoOrc(null);
    setPassoAdicionar("produto");
    setModalAberto("adicionar-orcamento");
  };

  // Abre o popup pra EDITAR um item já salvo dentro de um orçamento
  const editarItemOrc = (o, index) => {
    const item = o.itens[index];
    setOrcForm({
      nome: item.nome || "",
      altura: item.altura != null ? String(item.altura) : "",
      observacoes: item.observacoes || "",
      fotos: item.fotos || [],
      preco: item.preco != null ? String(item.preco) : "0",
      cores: item.cores || [],
      quantidade: item.quantidade ? String(item.quantidade) : "1",
      linkMakerworld: item.link_makerworld || "",
    });
    setNomeClienteForm(o.nomeCliente || "");
    setClienteSelId(o.clienteId || null);
    setEditandoOrc({ id:o.id, index });
    setModalAberto("orcamento");
  };

  // Acha o cadastro em Clientes com esse nome (ignora maiúsc./acento) ou cria
  // um novo — sem isso o orçamento só guardava um nome solto, sem nenhuma
  // conexão com o cadastro de clientes de verdade.
  const normalizarNome = (s) => (s||"").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,"").trim();

  // Orçamento "ativo" de um cliente = o mais recente que ainda não expirou
  // (mesmo critério de 14 dias que já valia pro rascunho único).
  const orcamentoExpirou = (o) => {
    const d = o.expira_em?.toDate ? o.expira_em.toDate() : null;
    return d ? d < new Date() : false;
  };
  const encontrarOrcamentoAtivoDoCliente = (nome, clienteId) => {
    const candidatos = orcamentosSalvos.filter(o => !orcamentoExpirou(o));
    if (clienteId) {
      const porId = candidatos.find(o => o.clienteId === clienteId);
      if (porId) return porId;
    }
    const alvo = normalizarNome(nome);
    if (!alvo) return null;
    return candidatos.find(o => normalizarNome(o.nomeCliente) === alvo) || null;
  };

  // Confirma o cliente escolhido (digitado, selecionado da lista, ou recém
  // cadastrado) e associa automaticamente ao orçamento ativo dele, se
  // existir — sem perguntar, sem popup intermediário. Se não existir, o
  // próximo item salvo cria um orçamento novo pra esse cliente.
  const confirmarClienteEAutoAssociar = (nome, clienteId) => {
    setNomeClienteForm(nome);
    setClienteSelId(clienteId || null);
    setBuscaClienteAberto(false);
    const ativo = encontrarOrcamentoAtivoDoCliente(nome, clienteId);
    if (ativo) { definirRascunho(ativo.id); setRascunho(ativo); }
    else if (rascunhoId) { encerrarRascunho(); }
  };

  const resolverClienteId = async (nome) => {
    const alvo = nome.trim();
    if (!alvo) return null;
    if (clienteSelId) {
      const selecionado = clientes.find(cl => cl.id === clienteSelId);
      if (selecionado && normalizarNome(selecionado.nome) === normalizarNome(alvo)) return clienteSelId;
    }
    const existente = clientes.find(cl => normalizarNome(cl.nome) === normalizarNome(alvo));
    if (existente) return existente.id;
    try {
      const ref = await fbAdd("clientes", { nome: alvo, celular:"", aniversario:"", aceitaWhatsapp:false, tipo:"" });
      setClientes(prev => [...prev, { id: ref.id, nome: alvo }]);
      return ref.id;
    } catch { return null; }
  };

  // "+ Novo cliente" — cadastro mínimo (só o que o app já suporta), volta
  // sozinho pro fluxo com o cliente já selecionado e associado.
  const criarNovoCliente = async () => {
    const nome = novoClienteNome.trim();
    if (!nome) return;
    setSalvandoNovoCliente(true);
    try {
      const ref = await fbAdd("clientes", { nome, celular: novoClienteCelular.trim(), aniversario:"", aceitaWhatsapp:false, tipo:"" });
      setClientes(prev => [...prev, { id: ref.id, nome }]);
      confirmarClienteEAutoAssociar(nome, ref.id);
      setNovoClienteAberto(false);
      setNovoClienteNome(""); setNovoClienteCelular("");
      toast(`✅ Cliente "${nome}" cadastrado!`, "success");
    } catch (e) { toast("Erro ao cadastrar cliente: " + e.message, "error"); }
    setSalvandoNovoCliente(false);
  };

  // Regra: item de orçamento não pode ficar sem arquivo — migra pro Storage
  // definitivo do orçamento (orcamentos_arquivos/{orcamentoId}/...), igual
  // ao que registrarProduto já faz pro produto. Assim, quando "Registrar
  // Produto" for chamado a partir desse item depois, o arquivo já vem junto.
  // `arqFatiado`/`arq3mf`: por padrão os da tela; cada item de um lote passa o seu.
  const migrarArquivoParaOrcamento = async (orcamentoId, arqFatiado = arquivoFatiado, arq3mf = arquivo3mf) => {
    try {
      if (arqFatiado) {
        const resp = await fetch(arqFatiado.fileUrl);
        const blob = await resp.blob();
        const path = `orcamentos_arquivos/${orcamentoId}/${Date.now()}_${arqFatiado.fileName}`;
        const storageRef = ref(storage, path);
        await uploadBytes(storageRef, blob);
        const url = await getDownloadURL(storageRef);
        deleteObject(ref(storage, arqFatiado.storagePath)).catch(() => {}); // temporário — já foi "entregue" ao item
        return prepararArquivo3d(blob, { nome: arqFatiado.fileName, path, url }, arqFatiado);
      }
      if (arq3mf) {
        const path = `orcamentos_arquivos/${orcamentoId}/${Date.now()}_${arq3mf.name}`;
        const storageRef = ref(storage, path);
        await uploadBytes(storageRef, arq3mf);
        const url = await getDownloadURL(storageRef);
        return prepararArquivo3d(arq3mf, { nome: arq3mf.name, path, url });
      }
    } catch (e) { console.error("Erro ao migrar arquivo pro orçamento:", e); }
    return null;
  };

  const salvarOrc = async () => {
    const u = getUser();
    if (!u?.uid) { toast("Sessão expirada, faça login de novo.", "error"); return; }
    const linkOrcMakerworld = (orcForm.linkMakerworld || "").trim();
    if (linkOrcMakerworld && !/^https?:\/\/\S+$/i.test(linkOrcMakerworld)) { toast("O link do MakerWorld precisa começar com https://", "warning"); return; }
    if (!editandoOrc && !rascunhoId && !nomeClienteForm.trim()) {
      toast("Informe o nome do cliente pra começar o orçamento!", "warning");
      return;
    }
    // Arquivo não é obrigatório — só confirma se a pessoa quer mesmo seguir sem ele.
    if (!editandoOrc && !arquivoFatiado && !arquivo3mf) {
      if (!await confirmar("Tem certeza que vai salvar sem o arquivo (.3mf)?")) return;
    }
    setSalvandoOrc(true);
    try {
      const item = {
        nome: orcForm.nome.trim() || calculo.nome.trim() || "Item sem nome",
        fotos: orcForm.fotos,
        altura: orcForm.altura ? parseFloat(orcForm.altura) : null,
        observacoes: orcForm.observacoes.trim() || null,
        preco: parseFloat((parseFloat(orcForm.preco) || 0).toFixed(2)),
        quantidade: Math.max(1, parseInt(orcForm.quantidade) || 1),
        cores: orcForm.cores,
        // Origem do modelo — dado interno, nunca vai pro link público (ver gerarLinkOrcamento).
        link_makerworld: linkOrcMakerworld || null,
      };
      if (editandoOrc) {
        await atualizarItemOrcamento(u.uid, editandoOrc.id, editandoOrc.index, item);
        if (nomeClienteForm.trim()) {
          const cid = await resolverClienteId(nomeClienteForm);
          await atualizarNomeClienteOrcamento(u.uid, editandoOrc.id, nomeClienteForm.trim(), cid);
        }
        toast("✅ Item atualizado! Mesmo link de antes, se já tinha um gerado.", "success");
        if (editandoOrc.id === rascunhoId) await atualizarRascunho();
      } else {
        // dados internos do item — nunca vão pro link público (ver
        // gerarLinkOrcamento) — guardados só pra "Editar cálculo" reconstruir
        // o cálculo inteiro desse item depois.
        const itemCompleto = {
          ...item,
          custo_total: parseFloat((resultado.custoTotal / calculo.uns).toFixed(2)),
          margem: resultado.custoTotal > 0 ? ((resultado.precoFinal - resultado.custoTotal) / resultado.custoTotal) * 100 : 0,
          margem_pct: resultado.margemReal,
          markup: resultado.markup,
          horas_impressao: arredondarHoras(parseFloat(calculo.horas)) || null,
          impressora_id: calculo.impressoraId || null,
          mao_obra_hrs: parseFloat(calculo.maoObraHrs) || null,
          mao_obra_valor_hr: parseFloat(calculo.maoObraValorHr) || null,
          unidades: calculo.uns,
          filamentos_usados: calculo.filamentosCalc,
          materiais_usados: calculo.materiaisCalc,
          custos_adicionais: calculo.custosAdicionais,
          taxas_usadas: calculo.taxas,
        };
        // Recalcula o orçamento ativo do cliente digitado/selecionado agora,
        // em vez de confiar cegamente no estado `rascunhoId` — que pode estar
        // um passo atrás se "Salvar" foi clicado logo após digitar o nome,
        // sem dar tempo do auto-associar (blur/seleção) atualizar o estado.
        // Evita tanto duplicar orçamento quanto, pior, colar o item no
        // orçamento de outro cliente por engano.
        const orcamentoAtivo = encontrarOrcamentoAtivoDoCliente(nomeClienteForm, clienteSelId);
        let orcamentoId, indiceNovoItem;
        if (orcamentoAtivo) {
          orcamentoId = orcamentoAtivo.id;
          indiceNovoItem = orcamentoAtivo.itens?.length || 0;
          await adicionarItemOrcamento(u.uid, orcamentoId, itemCompleto);
          if (orcamentoId !== rascunhoId) definirRascunho(orcamentoId);
        } else {
          const cid = await resolverClienteId(nomeClienteForm);
          orcamentoId = await salvarOrcamento(u.uid, { nomeCliente:nomeClienteForm, clienteId:cid, item:itemCompleto });
          indiceNovoItem = 0;
          definirRascunho(orcamentoId);
        }
        const arquivoItem = await migrarArquivoParaOrcamento(orcamentoId);
        const modelo3dItem = modelo3dFile
          ? await prepararModelo3dExibicao(`orcamentos_arquivos/${orcamentoId}`, modelo3dFile).catch(() => null)
          : null;
        if (arquivoItem || modelo3dItem) {
          await atualizarItemOrcamento(u.uid, orcamentoId, indiceNovoItem, {
            ...(arquivoItem ? { arquivo: arquivoItem } : {}),
            ...(modelo3dItem ? { visualizacao3d: modelo3dItem.visualizacao3d } : {}),
          });
        }
        await atualizarRascunho(orcamentoId);
        toast(orcamentoAtivo ? `➕ Item adicionado ao orçamento de ${orcamentoAtivo.nomeCliente || nomeClienteForm || "cliente"}!` : "🧾 Orçamento criado! Continue calculando e adicionando mais itens, ou finalize em \"Meus orçamentos\" pra gerar o link.", "success");
        const custosAdicionaisTotal = resultado.detalhamento.filter(d=>d.categoria==="adicional").reduce((s,d)=>s+d.valor,0);
        salvarHistoricoCalculo(u.uid, { ...resultado, custosAdicionaisTotal, origem:"orcamento" });
        resetCalculadora();
        // Item calculado veio do passo "Itens" do wizard "Novo Orçamento" —
        // volta pra lá em vez de ficar na Calculadora.
        if (voltarParaWizard) { setVoltarParaWizard(false); setWizardStep("itens"); setTela("novo-orcamento"); }
      }
      await abrirListaOrcamentos();
      setOrcForm({ nome:"", altura:"", observacoes:"", fotos:[], preco:"", cores:[], quantidade:"1", linkMakerworld:"" });
      setEditandoOrc(null);
      setClienteSelId(null);
      setModalAberto(null);
    } catch (e) { toast("Erro ao salvar: " + e.message, "error"); }
    setSalvandoOrc(false);
  };

  // Vários arquivos: cada um entra como um item do MESMO orçamento do cliente (o
  // ativo dele, ou um novo), com o próprio preço, custo e arquivo. Se algum falhar,
  // os já salvos saem do lote para não duplicar ao tentar de novo.
  const salvarOrcLote = async () => {
    const u = getUser();
    if (!u?.uid) { toast("Sessão expirada, faça login de novo.", "error"); return; }
    if (!rascunhoId && !nomeClienteForm.trim()) {
      toast("Informe o nome do cliente pra começar o orçamento!", "warning");
      return;
    }
    const itens = itensAtualizados();
    setSalvandoOrc(true);
    const salvos = [];
    try {
      const orcamentoAtivo = encontrarOrcamentoAtivoDoCliente(nomeClienteForm, clienteSelId);
      let orcamentoId = orcamentoAtivo?.id || null;
      let indice = orcamentoAtivo?.itens?.length || 0;
      for (const it of itens) {
        const form = loteOrc.find(l => l.id === it.id);
        const res = calcularResultado(it.calculo);
        const uns = unidadesDoItem(it.calculo);
        const itemCompleto = {
          nome: form.nome.trim() || nomeDoItem(it),
          fotos: [], altura: null, observacoes: null,
          preco: parseFloat((parseFloat(form.preco) || 0).toFixed(2)),
          quantidade: Math.max(1, parseInt(form.quantidade) || 1),
          cores: form.cores,
          // dados internos — nunca vão pro link público (ver gerarLinkOrcamento)
          custo_total: parseFloat((res.custoTotal / uns).toFixed(2)),
          margem: res.custoTotal > 0 ? ((res.precoFinal - res.custoTotal) / res.custoTotal) * 100 : 0,
          margem_pct: res.margemReal,
          markup: res.markup,
          horas_impressao: arredondarHoras(parseFloat(it.calculo.horas)) || null,
          impressora_id: it.calculo.impressoraId || null,
          mao_obra_hrs: parseFloat(it.calculo.maoObraHrs) || null,
          mao_obra_valor_hr: parseFloat(it.calculo.maoObraValorHr) || null,
          unidades: uns,
          filamentos_usados: it.calculo.filamentosCalc,
          materiais_usados: it.calculo.materiaisCalc,
          custos_adicionais: it.calculo.custosAdicionais,
          taxas_usadas: it.calculo.taxas,
        };
        if (orcamentoId) {
          await adicionarItemOrcamento(u.uid, orcamentoId, itemCompleto);
          if (orcamentoId !== rascunhoId) definirRascunho(orcamentoId);
        } else {
          const cid = await resolverClienteId(nomeClienteForm);
          orcamentoId = await salvarOrcamento(u.uid, { nomeCliente:nomeClienteForm, clienteId:cid, item:itemCompleto });
          definirRascunho(orcamentoId);
        }
        const arquivoItem = await migrarArquivoParaOrcamento(orcamentoId, it.arquivoFatiado, null);
        if (arquivoItem) await atualizarItemOrcamento(u.uid, orcamentoId, indice, { arquivo: arquivoItem });
        indice += 1;
        salvos.push(it.id);
        const custosAdicionaisTotal = res.detalhamento.filter(d=>d.categoria==="adicional").reduce((s,d)=>s+d.valor,0);
        salvarHistoricoCalculo(u.uid, { ...res, custosAdicionaisTotal, origem:"orcamento" });
      }
      await atualizarRascunho(orcamentoId);
      toast(orcamentoAtivo
        ? `➕ ${itens.length} itens adicionados ao orçamento de ${orcamentoAtivo.nomeCliente || nomeClienteForm || "cliente"}!`
        : `🧾 Orçamento criado com ${itens.length} itens! Continue calculando e adicionando mais, ou finalize em "Meus orçamentos" pra gerar o link.`, "success");
      resetCalculadora();
      if (voltarParaWizard) { setVoltarParaWizard(false); setWizardStep("itens"); setTela("novo-orcamento"); }
      await abrirListaOrcamentos();
      setOrcForm({ nome:"", altura:"", observacoes:"", fotos:[], preco:"", cores:[], quantidade:"1", linkMakerworld:"" });
      setEditandoOrc(null);
      setClienteSelId(null);
      setModalAberto(null);
    } catch (e) {
      toast(`Erro ao salvar: ${e.message}${salvos.length ? ` — ${salvos.length} de ${itens.length} itens já entraram no orçamento e saíram da lista.` : ""}`, "error");
      if (salvos.length) {
        retirarItensDoLote(salvos, false);
        // Recarrega a lista: se o orçamento acabou de ser criado, o próximo clique precisa
        // achá-lo (senão criaria um segundo orçamento para o mesmo cliente).
        try { await abrirListaOrcamentos(); } catch {}
      }
    }
    setSalvandoOrc(false);
  };

  // Traz um item salvo de volta pro formulário principal da calculadora —
  // reconstrói filamentos, materiais, horas, margem, mão de obra e desconto,
  // pra poder editar TUDO (não só os campos rápidos do popup de orçamento).
  const carregarItemNaCalculadora = (o, index) => {
    const item = o.itens[index];
    setItensArquivo([]); setItemAtivoId(null); // edição de um item salvo não convive com o lote de arquivos
    calculo.setFilamentosCalc((item.filamentos_usados || []).map(f => ({ ...f })));
    calculo.setMateriaisCalc((item.materiais_usados || []).map(m => ({ ...m })));
    calculo.setCustosAdicionais(item.custos_adicionais || []);
    calculo.setTaxas(item.taxas_usadas || []);
    calculo.setHoras(item.horas_impressao != null ? String(item.horas_impressao) : "");
    if (item.impressora_id) calculo.selecionarImpressora(item.impressora_id);
    calculo.setMaoObraHrs(item.mao_obra_hrs != null ? String(item.mao_obra_hrs) : "");
    calculo.setMaoObraValorHr(item.mao_obra_valor_hr != null ? String(item.mao_obra_valor_hr) : "");
    calculo.setNome(item.nome || "");
    calculo.setUnidades(item.unidades ? String(item.unidades) : "1");
    // Reconstrói pelo PREÇO já salvo (modo 'preco') — funciona não importa
    // como a margem tinha sido definida originalmente, sempre reproduz o
    // mesmo valor; o usuário troca de objetivo depois se quiser reajustar.
    calculo.setModo("preco");
    calculo.setValorAlvo(String(((parseFloat(item.preco) || 0) * (item.unidades || 1)).toFixed(2)));
    setCalcCarregado({ id:o.id, index, nomeCliente:o.nomeCliente, nomeItem:item.nome });
    setModalAberto(null);
    setTela("calculadora");
    toast(`🧮 "${item.nome}" carregado na calculadora — ajuste cores, margem, preço etc. e clique em "Salvar no orçamento".`, "success");
  };

  // Recalcula com os valores atuais da tela e grava de volta no MESMO item
  // (cores, custo, margem, mão de obra, preço final — tudo).
  const salvarAlteracoesOrcamentoCarregado = async () => {
    const u = getUser();
    if (!u?.uid || !calcCarregado) return;
    setSalvandoOrc(true);
    try {
      const cores = calculo.filamentosCalc.map(f => ({ nome:f.nome, material:f.material, hex:corFilamentoHex(f.nome, coresCustom) }));
      const arquivoNovo = (arquivoFatiado || arquivo3mf) ? await migrarArquivoParaOrcamento(calcCarregado.id) : null;
      await atualizarItemOrcamento(u.uid, calcCarregado.id, calcCarregado.index, {
        ...(arquivoNovo ? { arquivo: arquivoNovo } : {}),
        nome: calculo.nome.trim() || calcCarregado.nomeItem || "Item sem nome",
        preco: parseFloat((resultado.precoFinal / calculo.uns).toFixed(2)),
        cores,
        custo_total: parseFloat((resultado.custoTotal / calculo.uns).toFixed(2)),
        margem: resultado.custoTotal > 0 ? ((resultado.precoFinal - resultado.custoTotal) / resultado.custoTotal) * 100 : 0,
        margem_pct: resultado.margemReal,
        markup: resultado.markup,
        horas_impressao: arredondarHoras(parseFloat(calculo.horas)) || null,
        impressora_id: calculo.impressoraId || null,
        mao_obra_hrs: parseFloat(calculo.maoObraHrs) || null,
        mao_obra_valor_hr: parseFloat(calculo.maoObraValorHr) || null,
        unidades: calculo.uns,
        filamentos_usados: calculo.filamentosCalc,
        materiais_usados: calculo.materiaisCalc,
        custos_adicionais: calculo.custosAdicionais,
        taxas_usadas: calculo.taxas,
      });
      toast("✅ Item atualizado com os novos valores! Mesmo link de antes, se já tinha um gerado.", "success");
      if (calcCarregado.id === rascunhoId) await atualizarRascunho();
      setCalcCarregado(null);
    } catch (e) { toast("Erro ao salvar: " + e.message, "error"); }
    setSalvandoOrc(false);
  };

  // Registra direto no estoque usando o que já está salvo no item do
  // orçamento (custo, margem, filamentos...) — sem precisar recarregar na
  // calculadora primeiro.
  const registrarProdutoDeItem = async (o, index) => {
    const item = o.itens[index];
    if (!item?.nome?.trim()) { toast("Esse item não tem nome.", "warning"); return; }
    // Arquivo não é obrigatório — só confirma se a pessoa quer mesmo registrar sem ele.
    if (!item.arquivo?.url) {
      if (!await confirmar("Esse item não tem arquivo (.3mf) anexado. Tem certeza que vai registrar sem o arquivo?")) return;
    }
    const key = `${o.id}:${index}`;
    setRegistrandoItemKey(key);
    try {
      const imp = impressoras.find(i => i.id === item.impressora_id);
      const categoriasDisponiveisItem = await fbList("categorias").catch(() => []);
      const categoriasDoItem = sugerirCategoriasProduto(item.nome, categoriasDisponiveisItem);
      const docRef = await fbAdd("produtos", {
        nome: item.nome.trim(),
        categorias: categoriasDoItem,
        categoria: categoriasDoItem[0] || null,
        categoria_auto: categoriasDoItem.length > 0,
        preco: parseFloat(item.preco || 0),
        custo_total: parseFloat(item.custo_total || 0),
        margem: item.margem || 0,
        estoque: 0,
        unidades: item.unidades || 1,
        ativo: false,
        fotoBase64: item.fotos?.[0] || null,
        horas_impressao: item.horas_impressao ?? null,
        impressora_id: item.impressora_id || null,
        impressora_nome: imp?.nome || null,
        mao_obra_hrs: item.mao_obra_hrs ?? null,
        mao_obra_valor_hr: item.mao_obra_valor_hr ?? null,
        filamentos_usados: item.filamentos_usados || [],
        materiais_usados: item.materiais_usados || [],
        ...(item.link_makerworld ? { link_makerworld: item.link_makerworld } : {}),
      });
      // Sobe TODAS as fotos do orçamento pra galeria do produto — não só a
      // primeira, que era o que "fotoBase64" (capa) já cobria sozinha.
      if (item.fotos?.length && docRef?.id) {
        const fotosSalvas = [];
        for (let i = 0; i < item.fotos.length; i++) {
          const foto = await salvarFotoBase64NoStorage(docRef.id, item.fotos[i], i === 0 ? "foto-principal" : `foto-${i + 1}`);
          if (foto) fotosSalvas.push(foto);
        }
        if (fotosSalvas.length) await fbUpdate("produtos", docRef.id, { fotos: fotosSalvas }).catch(() => {});
      }
      // Copia o arquivo do orçamento pro espaço definitivo do produto — não
      // aponta pro mesmo arquivo do orçamento, que pode ser apagado depois.
      if (item.arquivo?.url && docRef?.id) {
        try {
          const resp = await fetch(item.arquivo.url);
          const blob = await resp.blob();
          const path = `produtos/${docRef.id}/${Date.now()}_${item.arquivo.nome}`;
          const storageRef = ref(storage, path);
          await uploadBytes(storageRef, blob);
          const url = await getDownloadURL(storageRef);
          const arquivo = arquivoPermanente3d(item.arquivo, { nome: item.arquivo.nome, path, url });
          await fbUpdate("produtos", docRef.id, { arquivos: [arquivo] });
        } catch {}
      }
      // O modelo 3D de exibição do item (se explicitamente colocado) segue
      // pro produto novo — sem isso, o "Ver em 3D" some ao converter.
      if (item.visualizacao3d && docRef?.id) {
        await fbUpdate("produtos", docRef.id, { visualizacao3d: item.visualizacao3d }).catch(() => {});
      }
      toast(`📦 Produto "${item.nome}" registrado a partir do orçamento!`, "success");
    } catch (e) { toast("Erro ao registrar: " + e.message, "error"); }
    setRegistrandoItemKey(null);
  };

  const removerItemDoOrcamento = async (o, index) => {
    if (!await confirmar(o.itens.length <= 1 ? `Excluir o orçamento de "${o.nomeCliente}"? Esta ação não pode ser desfeita.` : `Remover "${o.itens[index]?.nome}" do orçamento de "${o.nomeCliente}"?`)) return;
    const u = getUser();
    try {
      const arquivoPath = o.itens[index]?.arquivo?.path;
      await removerItemOrcamento(u.uid, o, index);
      if (arquivoPath && !o.itens[index]?.pedido_id && !o.itens[index]?.arquivo?.compartilhado) deleteObject(ref(storage, arquivoPath)).catch(() => {});
      if (o.itens.length <= 1 && o.id === rascunhoId) encerrarRascunho();
      else if (o.id === rascunhoId) await atualizarRascunho();
      await abrirListaOrcamentos();
      toast("🗑️ Removido.", "success");
    } catch (e) { toast("Erro: " + e.message, "error"); }
  };

  const adicionarCatalogoAoOrcamento = async item => {
    const u = getUser();
    if (!u?.uid || !catalogoOrcamento?.id) throw new Error("Sessão expirada. Entre novamente para adicionar o produto.");
    const atualizado = await adicionarItemOrcamento(u.uid, catalogoOrcamento.id, item);
    setOrcamentosSalvos(lista => lista.map(o => o.id === atualizado.id ? { ...o, ...atualizado } : o));
    if (atualizado.id === rascunhoId) setRascunho(atualizado);
    toast("Produto adicionado ao carrinho de " + atualizado.nomeCliente + ".", "success");
  };

  const abrirListaOrcamentos = async () => {
    setCarregandoOrcamentos(true);
    try {
      const u = getUser();
      const lista = await listarOrcamentos(u.uid);
      const comStatus = await Promise.all(lista.map(async o => {
        if (!o.link_gerado) return o;
        try {
          const snap = await getDoc(doc(db, `users/${u.uid}/orcamentos_publicos`, o.id));
          if (snap.exists()) {
            const p = snap.data();
            const totalItens = (o.itens||[]).length;
            // Docs antigos (de antes da aprovação virar por item) têm um
            // "aprovado" único pro orçamento inteiro — trata como "todos".
            const aprovados = p.aprovados || (p.aprovado ? Object.fromEntries((o.itens||[]).map((_,i)=>[i,true])) : {});
            const aprovadosCount = Object.values(aprovados).filter(Boolean).length;
            return { ...o, _pub: { aprovados, aprovadosCount, totalItens, pedidosRegistrados: p.pedidosRegistrados || {}, ultima_visualizacao_em:p.ultima_visualizacao_em, expira_em:p.expira_em } };
          }
        } catch {}
        return o;
      }));
      setOrcamentosSalvos(comStatus);
    } catch (e) { toast("Erro ao carregar orçamentos: " + e.message, "error"); }
    setCarregandoOrcamentos(false);
  };
  const carregarHistorico = async () => {
    const u = getUser();
    if (!u?.uid) return;
    setCarregandoHistorico(true);
    try { setHistorico(await listarHistoricoCalculos(u.uid)); }
    catch (e) { toast("Erro ao carregar histórico: " + e.message, "error"); }
    setCarregandoHistorico(false);
  };

  // "🧮 Calcular item" (dentro do wizard) leva pra Calculadora pra montar o
  // item — precisa voltar pro wizard depois, não ficar na Calculadora.
  const irParaCalculoDoWizard = () => { setVoltarParaWizard(true); setTela("calculadora"); };

  // Anexa um .3mf a um item já salvo do orçamento (passo "Itens" do wizard).
  const escolherArquivoParaItem = (index) => { setAnexandoIdxAtual(index); arquivoOrcRef.current?.click(); };
  const handleArquivoItemWizard = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    const index = anexandoIdxAtual;
    if (!file || index == null) return;
    const u = getUser();
    if (!u?.uid || !rascunhoId) return;
    setAnexandoArquivoIdx(index);
    try {
      const path = `orcamentos_arquivos/${rascunhoId}/${Date.now()}_${file.name}`;
      const storageRef = ref(storage, path);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);
      const arquivo = await prepararArquivo3d(file, { nome: file.name, path, url });
      await atualizarItemOrcamento(u.uid, rascunhoId, index, { arquivo });
      await atualizarRascunho();
      toast("📎 Arquivo anexado!", "success");
    } catch (e) { toast("Erro ao anexar: " + e.message, "error"); }
    setAnexandoArquivoIdx(null);
    setAnexandoIdxAtual(null);
  };

  // Margem e preço manual compartilham a mesma prévia e gravam o carrinho inteiro.
  const aplicarAjusteMargem = async (orcamento, opcoes = {modo:"margem", valorAlvo:ajusteMargemAlvo}) => {
    const u = getUser();
    if (!u?.uid || !orcamento || aplicandoAjuste) return false;
    setAplicandoAjuste(true);
    try {
      const plano = planejarPrecoOrcamento(orcamento.itens || [], {...opcoes, taxas:calculo.taxas});
      const atualizado = await atualizarPrecosOrcamento(u.uid, orcamento.id, orcamento.itens, plano.precos);
      setOrcamentosSalvos(lista => lista.map(o => o.id === atualizado.id ? {...o, ...atualizado} : o));
      if (orcamento.id === rascunhoId) setRascunho(atualizado);
      salvarHistoricoCalculo(u.uid, { ...plano.resultado, custosAdicionaisTotal:0, origem:"orcamento" });
      setAjustarPrecoAberto(false);
      toast(`Preço do orçamento atualizado para ${moedaOrcamento(plano.resultado.precoFinal)}.`, "success");
      return true;
    } catch (e) {
      toast("Erro ao ajustar: " + e.message, "error");
      return false;
    } finally { setAplicandoAjuste(false); }
  };

  // Reaplica um cálculo salvo no histórico — leva de volta pra Calculadora
  // com custo/margem daquele momento, pronto pra ajustar e usar de novo.
  const reaplicarHistorico = (h) => {
    setItensArquivo([]); setItemAtivoId(null);
    calculo.setFilamentosCalc([]);
    calculo.setMateriaisCalc([]);
    calculo.setTaxas([]);
    calculo.setHoras("");
    calculo.setMaoObraHrs(""); calculo.setMaoObraValorHr("");
    // O custo de filamento/tempo não dá pra reconstruir linha a linha (não
    // foi salvo assim) — entra como "custos adicionais" fixos equivalentes,
    // pra não perder o número, e o motor de preço resolve normalmente.
    const custosReconstruidos = [{ id:"hist-custo", nome:"Custo (do histórico)", tipo:"fixo", valor:h.custoTotal }];
    if (h.custosAdicionaisTotal > 0) custosReconstruidos.push({ id:"hist-adic", nome:"Custos adicionais (histórico)", tipo:"fixo", valor:h.custosAdicionaisTotal });
    calculo.setCustosAdicionais(custosReconstruidos);
    calculo.setModo("margem");
    calculo.setValorAlvo(String(h.margemReal.toFixed(0)));
    setTela("calculadora");
    toast("↻ Cálculo do histórico carregado.", "success");
  };

  const gerarLink = async (o) => {
    const u = getUser();
    setGerandoLinkId(o.id);
    try {
      const url = await gerarLinkOrcamento(u.uid, o);
      try { await navigator.clipboard.writeText(url); toast("🔗 Link copiado! Válido por 3 dias.", "success"); }
      catch { toast("🔗 Link gerado: " + url, "success"); }
      await abrirListaOrcamentos();
    } catch (e) { toast("Erro ao gerar link: " + e.message, "error"); }
    setGerandoLinkId(null);
  };

  const copiarLink = async (o) => {
    try { await navigator.clipboard.writeText(linkOrcamento(o)); toast("📋 Link copiado!", "success"); }
    catch { toast("Não foi possível copiar.", "error"); }
  };

  const gerarPedidoManual = async o => {
    const u = getUser();
    if (!u?.uid) { toast("Sessão expirada, faça login de novo.", "error"); return; }
    if (criandoPedidoRef.current) return;
    criandoPedidoRef.current = true;
    setGerandoPedidoId(o.id);
    try {
      const pedido = await criarPedidoDoOrcamento(u.uid, o.id, produtos, clientes);
      if (pedido.criado) {
        setOrcamentosSalvos(lista => lista.map(orc => orc.id === o.id ? {...orc, itens:pedido.itens} : orc));
        if (o.id === rascunhoId) setRascunho(atual => ({...atual, itens:pedido.itens}));
        if (pedido.novosProdutos.length) setProdutos(lista => [...lista, ...pedido.novosProdutos]);
        toast("Pedido criado! Ele está em Pedidos, na etapa Conferindo pagamento.", "success");
      } else { toast("Os itens deste orçamento já têm pedido.", "success"); }
      await abrirListaOrcamentos();
    } catch (e) { toast("Não foi possível criar o pedido: " + e.message, "error"); }
    finally { criandoPedidoRef.current = false; setGerandoPedidoId(null); }
  };

  const excluirOrc = async (o) => {
    if (!await confirmar(`Excluir o orçamento de "${o.nomeCliente}" (${o.itens?.length||0} ${o.itens?.length===1?"item":"itens"})? Esta ação não pode ser desfeita.`)) return;
    const u = getUser();
    try {
      await apagarOrcamento(u.uid, o);
      (o.itens||[]).forEach(it => { if (it.arquivo?.path && !it.pedido_id) deleteObject(ref(storage, it.arquivo.path)).catch(() => {}); });
      setOrcamentosSalvos(arr => arr.filter(x => x.id !== o.id));
      if (o.id === rascunhoId) encerrarRascunho();
      toast("🗑️ Orçamento excluído.", "success");
    } catch (e) { toast("Erro: " + e.message, "error"); }
  };

  // Vários arquivos: preço e tempo do cálculo de cada aba (o ativo vem da tela).
  const itensDaTela = emLote ? itensAtualizados() : [];
  const resultadosLote = itensDaTela.map(it => calcularResultado(it.calculo));
  const loteViavel = resultadosLote.every(r => !r.inviavel && Number.isFinite(r.precoFinal));
  const abasArquivos = itensDaTela.map((it, i) => {
    const r = resultadosLote[i];
    const min = Math.round((parseFloat(it.calculo.horas) || 0) * 60);
    const tempo = min ? `${Math.floor(min / 60)}h ${min % 60}min` : "sem tempo";
    const preco = r.inviavel || !Number.isFinite(r.precoFinal) ? "preço inviável" : ocultar ? "R$ ••••" : moedaOrcamento(r.precoFinal);
    return { id: it.id, nome: nomeDoItem(it), thumbnail: it.fotoBase64 || null, detalhe: `${preco} · ${tempo}` };
  });

  return (
    <div className="calc-module" style={{ display:"flex", flexDirection:"column", gap:16 }}>
      {modalConfirm}
      {catalogoOrcamento && <CatalogoOrcamento produtos={produtos} cliente={catalogoOrcamento.nomeCliente} onClose={()=>setCatalogoOrcamento(null)} onAdicionar={adicionarCatalogoAoOrcamento} />}


      {/* ── Tela: Home da Calculadora — visão geral + atalhos ── */}
      {tela === "inicio" && (
        <Card>
          <TelaInicio
            orcamentosSalvos={orcamentosSalvos}
            onIrCalculadora={()=>setTela("calculadora")}
            onIrNovoOrcamento={()=>{ encerrarRascunho(); setNomeClienteForm(""); setClienteSelId(null); setWizardStep("cliente"); setTela("novo-orcamento"); }}
            onIrOrcamentos={()=>{ abrirListaOrcamentos(); setTela("orcamentos"); }}
            onIrHistorico={()=>{ carregarHistorico(); setTela("historico"); }}
          />
        </Card>
      )}

      {/* ── Tela: Calculadora de preço ── */}
      {tela === "calculadora" && (
        <section className="calc-page">
          <div className="calc-page-heading">
            <div>
              <h1>Calculadora de preço</h1>
              <p>Transforme os custos da impressão em um preço de venda.</p>
            </div>
            <button type="button" className="calc-button calc-button-outline calc-client-toggle"
              data-tour="calc-modo-cliente" onClick={toggleOcultar} aria-pressed={ocultar}
              aria-label={ocultar ? "Mostrar valores internos" : "Ocultar valores internos"}
              title={ocultar ? "Mostrar valores internos" : "Ocultar valores internos"}>
              <CalcIcon name={ocultar ? "hidden" : "eye"} /><span></span>
            </button>
          </div>
          <SubNavCalculadora tela="calculadora"
            onIrCalculadora={()=>setTela("calculadora")}
            onIrOrcamentos={()=>{ abrirListaOrcamentos(); setTela("orcamentos"); }}
            onIrHistorico={()=>{ carregarHistorico(); setTela("historico"); }}
            onIrInicio={()=>setTela("inicio")}
          />
          {calcCarregado && (
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap", background:"color-mix(in srgb, var(--pc-ui-38bdf8, #38bdf8) 13.33%, transparent)", border:"1px solid color-mix(in srgb, var(--pc-ui-38bdf8, #38bdf8) 33.33%, transparent)", borderRadius:10, padding:"12px 14px", marginBottom:18 }}>
              <div style={{ color:"#9edfff", fontSize:13, lineHeight:1.5 }}>Editando "{calcCarregado.nomeItem}" — orçamento de {calcCarregado.nomeCliente}.</div>
              <button type="button" className="calc-button calc-button-outline" onClick={()=>setCalcCarregado(null)}>Cancelar edição</button>
            </div>
          )}
          {emLote && (
            <AbasArquivos itens={abasArquivos} ativoId={itemAtivoId}
              nome={calculo.nome} onNome={calculo.setNome}
              onSelecionar={selecionarItemArquivo} onRemover={removerItemArquivo}
              onAdicionar={()=>fatiarRef.current.click()}
              ocupado={fatiando || fatiandoSlice || !!configFatiamento || salvandoOrc || registrando} />
          )}
          {arquivoFatiado && (
            <div className="calc-file-preview">
              {arquivoFatiado.thumbnail && <img src={arquivoFatiado.thumbnail} alt="" />}
              <span>{arquivoFatiado.fileName}</span>
            </div>
          )}
          <input ref={fatiarRef} type="file" accept=".3mf,.gcode" style={{ display:"none" }} onChange={handleFatiar} />
          <div>
            <TelaCalculadora calculo={{ ...calculo, coresCustom }} ocultar={ocultar}
              upload3mf={!IMPORTAR_3MF_ATIVO ? null : {
                onAbrir: ()=>fatiarRef.current.click(), fatiando, coresDetectadas, resumoImportacao,
                onAlterarCor: (i, patch)=>setCoresDetectadas(arr=>arr.map((x,xi)=>xi===i?{...x,...patch}:x)),
                onRemoverCor: i=>setCoresDetectadas(arr=>arr.filter((_,xi)=>xi!==i)),
                onConfirmar: adicionarCoresDetectadas, onCancelar: ()=>setCoresDetectadas(null),
              }}
              makerworld={{ dados: makerworld, onAbrir: ()=>abrirMakerWorld("completo", makerworld?.url || linkMakerworld), onLimpar: ()=>setMakerworld(null) }}
              acoes={emLote ? <>
                <button type="button" className="calc-button calc-button-primary"
                  disabled={salvandoOrc || !loteViavel || calculo.carregandoCadastro}
                  onClick={abrirNovoOrcamentoLote}>
                  <CalcIcon name="receipt" />
                  {salvandoOrc ? "Salvando…" : `${voltarParaWizard ? "Salvar orçamento" : "Criar orçamento"} (${itensArquivo.length} itens)`}
                </button>
                {!voltarParaWizard && <button type="button" className="calc-button calc-button-outline"
                  disabled={!loteViavel || calculo.carregandoCadastro}
                  onClick={()=>setModalAberto("registrar-varios")}><CalcIcon name="box" />Registrar {itensArquivo.length} produtos</button>}
              </> : <>
                <button type="button" className="calc-button calc-button-primary"
                  disabled={salvandoOrc || resultado.inviavel || !Number.isFinite(resultado.precoFinal) || calculo.carregandoCadastro}
                  onClick={calcCarregado ? salvarAlteracoesOrcamentoCarregado : abrirNovoOrcamento}>
                  <CalcIcon name="receipt" />
                  {salvandoOrc ? "Salvando…" : calcCarregado ? "Salvar no orçamento" : voltarParaWizard ? "Salvar orçamento" : "Criar orçamento"}
                </button>
                {!voltarParaWizard && <button type="button" className="calc-button calc-button-outline"
                  disabled={resultado.inviavel || !Number.isFinite(resultado.precoFinal) || calculo.carregandoCadastro}
                  onClick={()=>setModalAberto("registrar-produtos")}><CalcIcon name="box" />Registrar produtos</button>}
              </>}
            />
          </div>
        </section>
      )}

      {/* ── Tela: histórico de cálculos aplicados ── */}
      {tela === "historico" && (
        <section className="calc-page budget-page">
          <OrcamentoCabecalho titulo="Histórico de cálculos" descricao="Consulte os preços que você já aplicou e reaproveite seus cálculos." />
          <SubNavCalculadora tela="historico"
            onIrCalculadora={()=>setTela("calculadora")}
            onIrOrcamentos={()=>{ abrirListaOrcamentos(); setTela("orcamentos"); }}
            onIrHistorico={()=>{ carregarHistorico(); setTela("historico"); }}
            onIrInicio={()=>setTela("inicio")}
          />
          <TelaHistorico historico={historico} carregando={carregandoHistorico} onReaplicar={reaplicarHistorico} />
        </section>
      )}

      {tela === "orcamentos" && (
        <section className="calc-page budget-page">
          <OrcamentoCabecalho titulo="Orçamentos" descricao="Organize os produtos, acompanhe aprovações e transforme orçamentos em pedidos."
            acao={<OrcamentoBotao onClick={()=>{ encerrarRascunho(); setNomeClienteForm(""); setClienteSelId(null); setWizardStep("cliente"); setTela("novo-orcamento"); }}><CalcIcon name="plus" />Novo orçamento</OrcamentoBotao>} />
          <SubNavCalculadora tela="orcamentos"
            onIrCalculadora={()=>setTela("calculadora")}
            onIrOrcamentos={()=>{ abrirListaOrcamentos(); setTela("orcamentos"); }}
            onIrHistorico={()=>{ carregarHistorico(); setTela("historico"); }}
            onIrInicio={()=>setTela("inicio")}
          />
          <TelaOrcamentos orcamentos={orcamentosSalvos} carregando={carregandoOrcamentos} busca={buscaOrc} setBusca={setBuscaOrc} filtro={filtroOrc} setFiltro={setFiltroOrc} rascunhoId={rascunhoId} statusOrcamento={statusOrcamento}
            onAbrir={o=>{ setOrcamentoAtualId(o.id); setAjustarPrecoAberto(false); setTela("detalhes"); }} onExcluir={excluirOrc} />
        </section>
      )}

      {/* ── Tela: detalhes de um orçamento — itens, resumo financeiro, ações ── */}
      {tela === "detalhes" && (() => {
        const o = orcamentosSalvos.find(x => x.id === orcamentoAtualId);
        if (!o) return null;
        const itens = o.itens || [];
        const totalOrc = itens.reduce((s,it) => s + (parseFloat(it.preco)||0)*(it.quantidade||1), 0);
        const custoOrc = itens.reduce((s,it) => s + (parseFloat(it.custo_total)||0)*(it.quantidade||1), 0);
        const lucroOrc = totalOrc - custoOrc;
        const margemOrc = totalOrc > 0 ? (lucroOrc/totalOrc*100) : 0;
        const expiraDraft = o.expira_em?.toDate ? o.expira_em.toDate() : null;
        const diasRestantes = expiraDraft ? Math.max(0, Math.ceil((expiraDraft - new Date()) / 86400000)) : null;
        const linkExpirado = o._pub?.expira_em?.toDate ? o._pub.expira_em.toDate() < new Date() : true;
        return (
          <section className="calc-page budget-page">
            <OrcamentoCabecalho titulo="Detalhes do orçamento" descricao={`${o.nomeCliente} · ${itens.length} ${itens.length === 1 ? "item" : "itens"}${diasRestantes != null ? ` · expira em ${diasRestantes}d` : ""}`} onVoltar={()=>{ setAjustarPrecoAberto(false); abrirListaOrcamentos(); setTela("orcamentos"); }} />
            <SubNavCalculadora tela="orcamentos"
            onIrCalculadora={()=>setTela("calculadora")}
            onIrOrcamentos={()=>{ abrirListaOrcamentos(); setTela("orcamentos"); }}
            onIrHistorico={()=>{ carregarHistorico(); setTela("historico"); }}
            onIrInicio={()=>setTela("inicio")}
          />
            <div className="budget-split">
              <section className="budget-panel">
                <div className="quote-cart-heading">
                  <h3>Carrinho do cliente <span style={{color:C.muted, fontSize:13}}>({itens.length})</span></h3>
                  <OrcamentoBotao color="#008a75" onClick={()=>setCatalogoOrcamento(o)}><CalcIcon name="plus" />Adicionar produto</OrcamentoBotao>
                </div>
                <div className="commerce-stack">
                  {itens.map((item, i) => {
                    const key = `${o.id}:${i}`;
                    const itemAprovado = !!o._pub?.aprovados?.[i];
                    return <article className="quote-item" key={i}>
                      <div className="quote-item-header">
                        {item.fotos?.[0] ? <img src={item.fotos[0]} alt="" /> : <span className="quote-item-placeholder"><CalcIcon name="box" size={24} /></span>}
                        <div className="quote-item-name"><h4>{item.nome}</h4><p>{item.quantidade || 1} × {moedaOrcamento(item.preco)} · por unidade</p></div>
                        <span className="quote-item-price">{moedaOrcamento((parseFloat(item.preco)||0)*(item.quantidade||1))}</span>
                      </div>
                      {item.visualizacao3d && <Visualizador3D modelo={visualizacao3dDoItem(item)} nome={item.nome} />}
                      {(o.link_gerado || item.pedido_id) && <p className="commerce-hint" style={{color:itemAprovado || item.pedido_id?C.success:undefined}}>{item.pedido_id || o._pub?.pedidosRegistrados?.[i] ? "Pedido criado" : itemAprovado ? "Aprovado pelo cliente" : "Aguardando aprovação"}</p>}
                      <div className="quote-item-actions">
                        <OrcamentoBotao small outline onClick={()=>editarItemOrc(o, i)}>Editar item</OrcamentoBotao>
                        <details className="quote-more"><summary>Mais opções</summary><div className="commerce-actions">
                          <OrcamentoBotao small outline onClick={()=>carregarItemNaCalculadora(o, i)}>Editar cálculo</OrcamentoBotao>
                          {!item.produto_id && <OrcamentoBotao small outline onClick={()=>registrarProdutoDeItem(o, i)} disabled={registrandoItemKey===key}>{registrandoItemKey===key ? "Registrando…" : "Registrar no catálogo"}</OrcamentoBotao>}
                          <OrcamentoBotao small outline danger onClick={()=>removerItemDoOrcamento(o, i)}>Remover item</OrcamentoBotao>
                        </div></details>
                      </div>
                    </article>;
                  })}
                  {!itens.length && <p className="commerce-hint">Adicione um produto para começar o carrinho deste cliente.</p>}
                </div>
              </section>
              <OrcamentoFinanceiro total={totalOrc} custo={custoOrc} lucro={lucroOrc} margem={margemOrc}>
                <OrcamentoBotao color="#008a75" style={{width:"100%", marginBottom:12}} onClick={()=>gerarPedidoManual(o)} disabled={gerandoPedidoId===o.id || !itens.some((it,i)=>!it.pedido_id && !o._pub?.pedidosRegistrados?.[i])}>
                  {gerandoPedidoId===o.id ? "Criando pedido…" : itens.length && itens.every((it,i)=>it.pedido_id || o._pub?.pedidosRegistrados?.[i]) ? "Pedido criado" : "Criar pedido"}
                </OrcamentoBotao>
                {itens.some(it=>it.pedido_id) && <p className="commerce-hint" style={{margin:"0 0 12px", color:C.success}}>Pedido criado com os itens do orçamento.{onIrPedidos && <button className="quote-link" onClick={onIrPedidos}>Ver em Pedidos →</button>}</p>}
            <div className="budget-financial-actions">
              {(!o.link_gerado || linkExpirado) ? (
                <OrcamentoBotao outline onClick={()=>gerarLink(o)} disabled={gerandoLinkId===o.id}>
                  {gerandoLinkId===o.id ? "Aguarde…" : (o.link_gerado ? "Renovar link" : "Enviar para cliente")}
                </OrcamentoBotao>
              ) : (
                <>
                  <OrcamentoBotao outline onClick={()=>copiarLink(o)}>Copiar link</OrcamentoBotao>
                  <OrcamentoBotao small outline onClick={()=>window.open(linkOrcamento(o), "_blank")}>Abrir link</OrcamentoBotao>
                  <OrcamentoBotao small outline onClick={()=>gerarLink(o)} disabled={gerandoLinkId===o.id}>
                    {gerandoLinkId===o.id ? "Aguarde…" : "Atualizar link"}
                  </OrcamentoBotao>
                </>
              )}

            </div>

                {o.link_desatualizado && <p className="commerce-hint">Há produtos novos no carrinho. Use “Atualizar link” para mostrá-los ao cliente.</p>}
                <details className="quote-more" style={{marginTop:12}}><summary>Preço e outras ações</summary><div className="commerce-actions">
                  <OrcamentoBotao small outline onClick={()=>{ setAjusteMargemAlvo(margemOrc.toFixed(0)); setAjustarPrecoAberto(v=>!v); }}>Ajustar preço</OrcamentoBotao>
                  <OrcamentoBotao small outline danger onClick={()=>excluirOrc(o)}>Cancelar orçamento</OrcamentoBotao>
                </div></details>
              </OrcamentoFinanceiro>
            </div>
            {ajustarPrecoAberto && (() => {
              const previa = resolverPreco({ custoTotal:custoOrc, taxas:calculo.taxas, modo:"margem", valorAlvo:parseFloat(ajusteMargemAlvo)||0 });
              return <section className="budget-panel" style={{marginTop:24}} aria-label="Ajustar preço do orçamento">
                <div className="budget-section-heading"><h2>Ajustar preço do orçamento</h2><button type="button" className="budget-icon-button" onClick={()=>setAjustarPrecoAberto(false)} aria-label="Fechar ajuste de preço"><CalcIcon name="close" /></button></div>
                <div className="calc-target-row"><label htmlFor="budget-detail-margin">Margem sobre o preço de venda</label><div className="calc-target-input"><input id="budget-detail-margin" type="number" min="0" max={limiteMargemOrcamento} step="any" value={ajusteMargemAlvo} onChange={e=>setAjusteMargemAlvo(e.target.value)} /><span>%</span></div></div>
                <input className="calc-margin-slider" type="range" aria-label="Margem do orçamento" min="0" max={limiteMargemOrcamento} disabled={resultado.taxaTotalPct >= 100} value={ajusteMargemAlvo || 0} onChange={e=>setAjusteMargemAlvo(e.target.value)} />
                <div className="calc-range-labels"><span>0%</span><span>{limiteMargemOrcamento}%</span></div>
                <div className="budget-step-actions"><p className="budget-note">Novo total: <strong>{moedaOrcamento(previa.precoFinal)}</strong> · atual: {moedaOrcamento(totalOrc)}</p><OrcamentoBotao onClick={()=>aplicarAjusteMargem(o)} disabled={aplicandoAjuste || previa.inviavel}>{aplicandoAjuste ? "Aplicando…" : "Aplicar margem"}</OrcamentoBotao></div>
              </section>;
            })()}
          </section>
        );
      })()}

      {/* ── Tela: wizard "Novo Orçamento" — Cliente → Itens → Cálculo → Resumo.
          Cada item já é salvo no Firestore assim que é adicionado (mesma
          lógica de sempre); os passos só organizam a sequência. ── */}
      {tela === "novo-orcamento" && (
        <section className="calc-page budget-page">
          <OrcamentoCabecalho titulo="Novo orçamento" descricao="Monte os produtos e defina o preço para seu cliente." onVoltar={()=>{ abrirListaOrcamentos(); setTela("orcamentos"); }} />
          <SubNavCalculadora tela="orcamentos"
            onIrCalculadora={()=>setTela("calculadora")}
            onIrOrcamentos={()=>{ abrirListaOrcamentos(); setTela("orcamentos"); }}
            onIrHistorico={()=>{ carregarHistorico(); setTela("historico"); }}
            onIrInicio={()=>setTela("inicio")}
          />
          <TelaNovoOrcamento etapa={wizardStep} setEtapa={setWizardStep}
            nomeCliente={nomeClienteForm} setNomeCliente={setNomeClienteForm} clienteId={clienteSelId} setClienteId={setClienteSelId}
            buscaAberta={buscaClienteAberto} setBuscaAberta={setBuscaClienteAberto} clientes={clientes} normalizarNome={normalizarNome} onConfirmarCliente={confirmarClienteEAutoAssociar}
            rascunho={rascunho} rascunhoId={rascunhoId} onCalcularProduto={irParaCalculoDoWizard} onRemoverItem={removerItemDoOrcamento}
            arquivoRef={arquivoOrcRef} onArquivo={handleArquivoItemWizard} onEscolherArquivo={escolherArquivoParaItem} anexandoArquivoIdx={anexandoArquivoIdx}
            margem={ajusteMargemAlvo} setMargem={setAjusteMargemAlvo} limiteMargem={limiteMargemOrcamento} taxaTotalPct={resultado.taxaTotalPct} taxas={calculo.taxas}
            modo={wizardModoPreco} setModo={setWizardModoPreco} precoAlvo={wizardPrecoAlvo} setPrecoAlvo={setWizardPrecoAlvo}
            aplicando={aplicandoAjuste} onAplicarPreco={async opcoes=>{ if (await aplicarAjusteMargem(rascunho, opcoes)) setWizardStep("resumo"); }}
            onFinalizar={()=>{ setOrcamentoAtualId(rascunhoId); setTela("sucesso"); }} />
        </section>
      )}

      {/* ── Tela: sucesso ao finalizar o wizard ── */}
      {tela === "sucesso" && (
        <section className="calc-page budget-page">
          <TelaSucesso
            orcamento={orcamentosSalvos.find(x => x.id === orcamentoAtualId) || rascunho}
            onEnviar={()=>{ const o = orcamentosSalvos.find(x => x.id === orcamentoAtualId) || rascunho; if (o) gerarLink(o); setTela("detalhes"); }}
            onVerOrcamento={()=>setTela("detalhes")}
            onIrOrcamentos={()=>{ abrirListaOrcamentos(); setTela("orcamentos"); }}
          />
        </section>
      )}

      {/* Importação de resultados salvos ou fatiamento preservando o projeto. */}
      {configFatiamento && (
        <Popup titulo={selecaoJaFatiada ? "IMPORTAR PLACAS" : "FATIAR PROJETO 3MF"} cor={C.warning} onClose={() => !fatiandoSlice && cancelarConfigFatiamento()}>
          <p style={{ color:C.muted, fontSize:12, marginBottom:16, lineHeight:1.5 }}>
            {selecaoJaFatiada
              ? "Usa o tempo e o consumo salvos no arquivo."
              : "O tempo e o consumo serão calculados para a impressora selecionada."}
          </p>
          {!selecaoJaFatiada && kobraXSelecionada && (
            <p role="note" style={{ color:C.warning, fontSize:12, lineHeight:1.5 }}>
              ⚠️ Fatiador em fase de teste: pode apresentar erros. O resultado não é idêntico ao dos fatiadores convencionais, mas fica bem próximo.
            </p>
          )}
          {selecaoJaFatiada && (
            <p style={{ color:C.text, fontSize:12 }}>
              Perfil no arquivo: {configFatiamento.data.printer?.profile || configFatiamento.data.printer?.model || "Não informada"}
            </p>
          )}
          {!selecaoJaFatiada && (
            <p style={{ color:C.text, fontSize:12 }}>Fatiar para: <strong>{impressoraParaFatiar || "Selecione a impressora na calculadora"}</strong></p>
          )}
          {configFatiamento.placas?.length > 0 && (
            <div style={{ marginBottom:18 }}>
              <div style={{ color:C.warning, fontSize:12, fontWeight:700, marginBottom:4 }}>
                📦 {configFatiamento.placas.length === 1 ? "1 placa" : `${configFatiamento.placas.length} placas`}
              </div>
              {configFatiamento.placas.length > 1 && (<>
                <div style={{ color:C.muted, fontSize:11, marginBottom:8, lineHeight:1.4 }}>
                  O resultado soma as placas selecionadas.
                </div>
                <div style={{ display:"flex", gap:8, marginBottom:10 }}>
                  <Btn small outline disabled={fatiandoSlice} onClick={() => setConfigFatiamento(c => ({ ...c, placasEscolhidas: c.placas.map(p => p.indice) }))}>Todas</Btn>
                  <Btn small outline disabled={fatiandoSlice} onClick={() => setConfigFatiamento(c => ({ ...c, placasEscolhidas: [] }))}>Nenhuma</Btn>
                </div>
              </>)}
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(72px, 1fr))", gap:8 }}>
                {configFatiamento.placas.map(p => {
                  const marcada = configFatiamento.placasEscolhidas.includes(p.indice);
                  const toggle = () => setConfigFatiamento(c => ({
                    ...c,
                    placasEscolhidas: marcada ? c.placasEscolhidas.filter(i => i !== p.indice) : [...c.placasEscolhidas, p.indice],
                  }));
                  // Fatiando: salvas e já fatiadas ficam prontas, a da vez ganha o laser, o resto espera na fila.
                  const prog = fatiandoSlice && marcada && progressoFatiamento;
                  const pos = prog ? prog.pendentes.indexOf(p.indice) : -1;
                  const etapa = !prog ? null : pos === prog.feito ? "fatiando" : pos > prog.feito ? "fila" : "pronta";
                  const cor = etapa === "pronta" ? C.success : etapa === "fila" ? C.muted : C.warning;
                  return (
                    <button key={p.indice} type="button" onClick={toggle} disabled={fatiandoSlice} aria-pressed={marcada}
                      className={"slice-plate" + (etapa ? " is-" + etapa : "")}
                      style={{ position:"relative", display:"flex", flexDirection:"column", alignItems:"center", gap:4, background:marcada?withAlpha(cor, "22"):C.card, border:"2px solid "+(marcada?cor:C.border), borderRadius:8, padding:6, cursor:fatiandoSlice?"default":"pointer", opacity:etapa==="fila"?0.6:marcada?1:fatiandoSlice?0.3:0.55 }}>
                      <div className="slice-plate-check" style={{ position:"absolute", top:2, left:2, zIndex:1, width:16, height:16, borderRadius:4, background:marcada?cor:"transparent", border:"1.5px solid "+(marcada?cor:C.muted), display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, color:"var(--pc-ui-04111f, #04111f)", fontWeight:900 }}>{marcada ? "✓" : ""}</div>
                      <div className="slice-plate-thumb" style={{ position:"relative", width:56, height:56, borderRadius:6, overflow:"hidden", background:C.panel, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                        {p.thumbnail ? <img src={p.thumbnail} alt={p.nome} style={{ width:"100%", height:"100%", objectFit:"cover" }} /> : <span style={{ fontSize:18 }}>📦</span>}
                      </div>
                      <span title={p.nome} style={{ fontSize:10, color:marcada?cor:C.muted, fontWeight:etapa==="fatiando"?700:400, textAlign:"center", maxWidth:60, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                        {etapa === "fatiando" ? "Fatiando..." : etapa === "fila" ? "Na fila" : etapa === "pronta" ? "Pronta" : p.nome}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          )}
          {!selecaoJaFatiada && configFatiamento.data.hasPrintSettings === false && (
            <p role="alert" style={{ color:C.warning, fontSize:12 }}>O arquivo não contém um perfil completo. Salve o projeto com sua impressora e filamentos no Bambu Studio ou importe a placa já fatiada.</p>
          )}
          <div style={{ display:"flex", gap:10, marginTop:18 }}>
            <Btn outline onClick={cancelarConfigFatiamento} disabled={fatiandoSlice}>Cancelar</Btn>
            <Btn color={C.warning} onClick={confirmarConfigFatiamento} disabled={fatiandoSlice || !configFatiamento.placasEscolhidas.length || (!selecaoJaFatiada && (!impressoraParaFatiar || configFatiamento.data.hasPrintSettings === false))}>
              {fatiandoSlice
                ? progressoFatiamento ? `⏳ Fatiando placa ${Math.min(progressoFatiamento.feito + 1, progressoFatiamento.total)} de ${progressoFatiamento.total}...` : "⏳ Fatiando na nuvem..."
                : `${selecaoJaFatiada ? "Importar" : "Fatiar"} ${configFatiamento.placasEscolhidas.length} placa(s)`}
            </Btn>
          </div>
        </Popup>
      )}

      {/* Erro do fatiador, traduzido e explicado (ver utils/erroFatiamento).
          O arquivo já foi descartado (descartarArquivoComErro): para tentar
          de novo, envie o arquivo outra vez. */}
      {erroFatiamento && (
        <Popup titulo="⚠️ ERRO AO FATIAR" cor={C.danger} onClose={() => setErroFatiamento(null)}>
          <p style={{ color:C.text, fontSize:14, fontWeight:800, marginBottom:8 }}>{erroFatiamento.titulo}</p>
          <p style={{ color:C.muted, fontSize:12, lineHeight:1.5, marginBottom: erroFatiamento.dica ? 10 : 16 }}>{erroFatiamento.explicacao}</p>
          {erroFatiamento.dica && (
            <p style={{ color:C.warning, fontSize:12, lineHeight:1.5, marginBottom:16 }}>💡 {erroFatiamento.dica}</p>
          )}
          <Btn color={C.warning} onClick={() => setErroFatiamento(null)}>OK</Btn>
        </Popup>
      )}

      {/* Popup: registrar produtos, no mesmo padrão do registro de orçamento. */}
      {modalAberto === "registrar-produtos" && (
        <CommerceDialog className="budget-modal calc-budget-dialog budget-register-modal" title="Registrar produtos"
          subtitle="Confira o produto e o preço antes de salvar."
          onClose={()=>{ if (!registrando) cancelarRegistro(); }}
          footer={<>
            <OrcamentoBotao outline onClick={cancelarRegistro} disabled={registrando}>Cancelar</OrcamentoBotao>
            <OrcamentoBotao onClick={registrarProduto} disabled={registrando || carregandoFotosRegistro || !calculo.nome.trim()}>
              {registrando ? "Registrando..." : "Registrar produtos"}
            </OrcamentoBotao>
          </>}>
          <div className="budget-modal-stack">
            <OrcamentoCampo label="Nome do produto" value={calculo.nome} onChange={e=>calculo.setNome(e.target.value)} placeholder="Ex.: Dragão P, Suporte de parede..." />
            <div className="budget-modal-price"><div><span><small>Preço de venda {calculo.uns > 1 ? "por unidade" : ""}</small><strong>{moedaOrcamento(resultado.precoFinal / calculo.uns)}</strong></span></div>
              <p className="budget-note">Custo: {moedaOrcamento(resultado.custoTotal / calculo.uns)} | Lucro: {moedaOrcamento(resultado.lucroReal / calculo.uns)} ({resultado.margemReal.toFixed(0)}%)</p>
            </div>
            {/* A quantidade de peças por impressão é definida na calculadora
                (é lá que ela divide o custo e o preço); aqui só confirma. */}
            {calculo.uns > 1 && (
              <p className="budget-note">
                {calculo.uns} peças por impressão · {moedaOrcamento(resultado.precoFinal)} a impressão inteira.
                Pra mudar a quantidade, ajuste "Peças por impressão" na calculadora.
              </p>
            )}
            <div className="budget-modal-section budget-register-categories">
              <h3>Categorias <span className="budget-note">Opcional</span></h3>
              <button className="budget-register-category-toggle" type="button" aria-expanded={mostrarCategoriasRegistro}
                onClick={()=>setMostrarCategoriasRegistro(v=>!v)}>
                {categoriasRegistro.length ? categoriasRegistro.map(nome=>emojiDaCategoria(nome)+" "+nome).join(", ") : "Selecionar categorias"} {mostrarCategoriasRegistro ? "-" : "+"}
              </button>
              {!categoriasRegistroManual && sugerirCategoriasProduto(calculo.nome, categoriasDisponiveis).length > 0 &&
                <p className="budget-note">Sugestão automática: {sugerirCategoriasProduto(calculo.nome, categoriasDisponiveis).map(nome=>emojiDaCategoria(nome)+" "+nome).join(", ")}</p>}
              {mostrarCategoriasRegistro && <div className="budget-register-category-list">
                {categoriasDisponiveis.length === 0 && <p className="budget-note">Nenhuma categoria cadastrada.</p>}
                {categoriasDisponiveis.map(c=>{ const selecionada=categoriasRegistro.includes(c.nome); return <button type="button" key={c.id} className={selecionada ? "is-selected" : ""} aria-pressed={selecionada}
                  onClick={()=>{ setCategoriasRegistroManual(true); setCategoriasRegistro(atual=>selecionada ? atual.filter(nome=>nome!==c.nome) : [...atual,c.nome]); }}>
                  {emojiDaCategoria(c.nome)} {c.nome}
                </button>; })}
              </div>}
            </div>
            <div className="budget-modal-section"><h3>Fotos do produto <span className="budget-note">Opcional</span></h3>
              <FotoUploader fotos={fotosRegistro.map((url, i) => ({ id:i, url }))} onAdicionar={adicionarFotosRegistro}
                onRemover={i => setFotosRegistro(f => f.filter((_, fi) => fi !== i))}
                processando={carregandoFotosRegistro} disabled={registrando} accept="image/*" compact />
            </div>
            <div className="budget-modal-section"><h3><CalcIcon name="box" />MakerWorld <span className="budget-note">Opcional</span></h3>
              <CampoLinkMakerWorld valor={linkMakerworld} onChange={setLinkMakerworld} desabilitado={registrando}
                onImportar={()=>abrirMakerWorld("produto", linkMakerworld)} />
              {makerworld && <>
                <FaixaFotosMakerWorld previas={makerworld.previas} />
                <p className="budget-note">
                  {makerworld.fotosIds.length ? `${makerworld.fotosIds.length} foto(s) serão copiadas para a galeria do produto ao registrar.` : "Nenhuma foto escolhida."}
                </p>
              </>}
            </div>
            <div className="budget-modal-section"><h3><CalcIcon name="box" />Arquivo 3MF <span className="budget-note">Opcional</span></h3>
              {fotoBase64 && <img className="budget-register-preview" src={fotoBase64} alt="Prévia do produto" />}
              {(arquivo3mf || arquivoFatiado) && <p className="budget-note">{arquivo3mf?.name || arquivoFatiado?.fileName}</p>}
              <div className="commerce-actions">
                <OrcamentoBotao small outline onClick={()=>fotoRef.current?.click()} disabled={carregandoFoto}><CalcIcon name="upload" />{carregandoFoto ? "Carregando..." : (arquivo3mf || arquivoFatiado) ? "Substituir arquivo" : "Anexar arquivo"}</OrcamentoBotao>
                {arquivo3mf && <OrcamentoBotao small outline danger onClick={()=>{ setArquivo3mf(null); setFotoBase64(""); }}>Remover</OrcamentoBotao>}
              </div>
            </div>
            <div className="budget-modal-section"><h3><CalcIcon name="box" />Modelo 3D para exibição <span className="budget-note">Opcional</span></h3>
              <p className="budget-note">Ficará visível no site da loja.</p>
              {modelo3dFile && <p className="budget-note">{modelo3dFile.name}</p>}
              <div className="commerce-actions">
                <OrcamentoBotao small outline onClick={()=>modelo3dRef.current?.click()}><CalcIcon name="upload" />{modelo3dFile ? "Substituir modelo" : "Selecionar modelo"}</OrcamentoBotao>
                {modelo3dFile && <OrcamentoBotao small outline danger onClick={()=>setModelo3dFile(null)}>Remover</OrcamentoBotao>}
              </div>
            </div>
          </div>
        </CommerceDialog>
      )}

      {/* Popup: registrar vários arquivos de uma vez — um produto por arquivo, cada um
          com o próprio nome, unidades e preço (definidos na aba de cada arquivo). */}
      {modalAberto === "registrar-varios" && (
        <CommerceDialog className="budget-modal calc-budget-dialog budget-register-modal" title={`Registrar ${itensDaTela.length} produtos`}
          subtitle="Cada arquivo vira um produto, com o próprio preço."
          onClose={()=>{ if (!registrando) setModalAberto(null); }}
          footer={<>
            <OrcamentoBotao outline onClick={()=>setModalAberto(null)} disabled={registrando}>Cancelar</OrcamentoBotao>
            <OrcamentoBotao onClick={registrarProdutosLote} disabled={registrando || !loteViavel}>
              {registrando ? "Registrando..." : `Registrar ${itensDaTela.length} produtos`}
            </OrcamentoBotao>
          </>}>
          <div className="budget-modal-stack">
            {itensDaTela.map((it, i) => {
              const r = resultadosLote[i]; const uns = unidadesDoItem(it.calculo);
              return (
                <div className="budget-modal-price" key={it.id}>
                  <div><span><small>{i + 1}. {nomeDoItem(it)}{uns > 1 ? ` · ${uns} unidades` : ""}</small>
                    <strong>{moedaOrcamento(r.precoFinal / uns)}{uns > 1 ? " por unidade" : ""}</strong></span></div>
                  <p className="budget-note">Custo: {moedaOrcamento(r.custoTotal / uns)} | Lucro: {moedaOrcamento(r.lucroReal / uns)} ({r.margemReal.toFixed(0)}%)</p>
                </div>
              );
            })}
            <p className="budget-note">Para mudar o nome, as unidades ou o preço de um arquivo, feche e escolha a aba dele.</p>
          </div>
        </CommerceDialog>
      )}

      {/* Importação do MakerWorld — no fim, fora das telas, pra abrir também por cima
          dos pop-ups de registrar produto e de item do orçamento. */}
      {makerworldModo && <ImportarMakerWorldCalculadora key={makerworldModo} soFotos={makerworldModo !== "completo"}
        linkInicial={linkParaImportar} onFechar={()=>setMakerworldModo(null)} onConfirmar={confirmarMakerWorld} />}

      {/* Popup: editar um item já salvo do orçamento (adicionar item novo
          agora é o modal de 2 passos "adicionar-orcamento" abaixo). */}
      {modalAberto === "orcamento" && editandoOrc && (
        <CommerceDialog className="budget-modal calc-budget-dialog" title="Editar item do orçamento" onClose={()=>{ if (!salvandoOrc) setModalAberto(null); }} footer={<><OrcamentoBotao outline disabled={salvandoOrc} onClick={()=>setModalAberto(null)}>Cancelar</OrcamentoBotao><OrcamentoBotao onClick={salvarOrc} disabled={salvandoOrc}>{salvandoOrc ? "Salvando…" : "Salvar alterações"}</OrcamentoBotao></>}>
          <div className="budget-description">
            Mudou algo? Ajuste aqui e salve — se já tinha link gerado, o mesmo link já reflete a mudança.
          </div>

          <div style={{ marginBottom:12 }}>
            <OrcamentoCampo label="Nome do item" value={orcForm.nome} onChange={e=>setOrcForm(f=>({...f,nome:e.target.value}))} placeholder="Ex: Dragão P" />
          </div>

          <div className="budget-edit-fields">
            <OrcamentoCampo label="Altura (cm)" type="number" value={orcForm.altura} onChange={e=>setOrcForm(f=>({...f,altura:e.target.value}))} placeholder="Ex: 17" />
            <OrcamentoCampo label="Preço (R$)" type="number" min="0" step="any" value={orcForm.preco} onChange={e=>setOrcForm(f=>({...f,preco:e.target.value}))} />
            <OrcamentoCampo label="Quantidade" type="number" min="1" value={orcForm.quantidade} onChange={e=>setOrcForm(f=>({...f,quantidade:e.target.value}))} />
          </div>

          <div style={{ marginBottom:14 }}>
            <CampoLinkMakerWorld valor={orcForm.linkMakerworld} onChange={valor=>setOrcForm(f=>({...f,linkMakerworld:valor}))}
              desabilitado={salvandoOrc || carregandoFotoOrc} onImportar={()=>abrirMakerWorld("orcamento", orcForm.linkMakerworld)} />
          </div>

          <div style={{ marginBottom:14 }}>
            <label className="budget-field-label">Fotos</label>
            <FotoUploader
              fotos={orcForm.fotos.map((foto,i) => ({ id:i, url:foto }))}
              onAdicionar={adicionarFotosOrc}
              onRemover={removerFotoOrc}
              onAbrirZoom={setLightboxOrcIdx}
              processando={carregandoFotoOrc}
              accept="image/*"
              compact
            />
            <Lightbox fotos={orcForm.fotos} indiceInicial={lightboxOrcIdx||0} aberto={lightboxOrcIdx!==null} onFechar={()=>setLightboxOrcIdx(null)} />
          </div>

          {orcForm.cores.length > 0 && (
            <div style={{ marginBottom:14 }}>
              <label className="budget-field-label">Cores no orçamento</label>
              <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                {orcForm.cores.map((cor,i) => (
                  <div key={i} style={{ display:"flex", alignItems:"center", gap:6, background:C.card, border:"1px solid "+C.border, borderRadius:20, padding:"4px 10px 4px 6px" }}>
                    <div style={{ width:12, height:12, borderRadius:"50%", background:cor.hex||corFilamentoHex(cor.nome, coresCustom), border:"1px solid "+C.border }} />
                    <span style={{ color:C.text, fontSize:11, fontWeight:600 }}>{cor.nome}</span>
                    <button onClick={()=>setOrcForm(f=>({...f,cores:f.cores.filter((_,ci)=>ci!==i)}))}
                      style={{ background:"none", border:"none", color:C.muted, cursor:"pointer", fontSize:12, padding:0, lineHeight:1 }}>✕</button>
                  </div>
                ))}
              </div>
              <div style={{ color:C.muted, fontSize:10, marginTop:6 }}>Pra trocar as cores, monte o cálculo de novo na Calculadora e use "🧮 Editar cálculo" na lista de orçamentos.</div>
            </div>
          )}

          <div style={{ marginBottom:16 }}>
            <label className="budget-field-label" htmlFor="budget-item-notes">Observações</label>
            <textarea id="budget-item-notes" className="calc-input" value={orcForm.observacoes} onChange={e=>setOrcForm(f=>({...f,observacoes:e.target.value}))} rows={3}
              placeholder="Ex: prazo de entrega, detalhes do acabamento..."
              style={{resize:"vertical"}} />
          </div>


        </CommerceDialog>
      )}

      {modalAberto === "adicionar-orcamento" && (
        <ModalAdicionarOrcamento
          passo={passoAdicionar} setPasso={setPassoAdicionar}
          orcForm={orcForm} setOrcForm={setOrcForm}
          resultado={resultado} calculo={calculo} coresCustom={coresCustom}
          precoEditavel={precoEditavel} setPrecoEditavel={setPrecoEditavel}
          arquivoFatiado={arquivoFatiado} arquivo3mf={arquivo3mf}
          onSelecionarArquivo={()=>fotoRef.current.click()}
          onRemoverArquivo={()=>{ setArquivo3mf(null); setFotoBase64(""); }}
          carregandoFoto={carregandoFoto}
          modelo3dFile={modelo3dFile}
          onSelecionarModelo3d={()=>modelo3dRef.current.click()}
          onRemoverModelo3d={()=>setModelo3dFile(null)}
          adicionarFotosOrc={adicionarFotosOrc} removerFotoOrc={removerFotoOrc}
          carregandoFotoOrc={carregandoFotoOrc}
          onImportarMakerWorld={()=>abrirMakerWorld("orcamento", orcForm.linkMakerworld)}
          lightboxOrcIdx={lightboxOrcIdx} setLightboxOrcIdx={setLightboxOrcIdx}
          nomeClienteForm={nomeClienteForm} setNomeClienteForm={setNomeClienteForm}
          clienteSelId={clienteSelId} setClienteSelId={setClienteSelId}
          buscaClienteAberto={buscaClienteAberto} setBuscaClienteAberto={setBuscaClienteAberto}
          clientes={clientes} normalizarNome={normalizarNome}
          confirmarClienteEAutoAssociar={confirmarClienteEAutoAssociar}
          novoClienteAberto={novoClienteAberto} setNovoClienteAberto={setNovoClienteAberto}
          novoClienteNome={novoClienteNome} setNovoClienteNome={setNovoClienteNome}
          novoClienteCelular={novoClienteCelular} setNovoClienteCelular={setNovoClienteCelular}
          criarNovoCliente={criarNovoCliente} salvandoNovoCliente={salvandoNovoCliente}
          rascunho={rascunho} rascunhoId={rascunhoId}
          lote={loteOrc} setLote={setLoteOrc}
          salvarOrc={loteOrc ? salvarOrcLote : salvarOrc} salvandoOrc={salvandoOrc}
          confirmar={confirmar}
          pularCliente={voltarParaWizard}
          onFechar={()=>{ setModalAberto(null); setLoteOrc(null); }}
        />
      )}
      <input ref={fotoRef} type="file" accept=".3mf" style={{ display:"none" }} onChange={handleFoto} />
      <input ref={modelo3dRef} type="file" accept=".3mf,.stl,.obj" style={{ display:"none" }} onChange={handleModelo3d} />

    </div>
  );
}
